import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ApiGetUploadedFiles,
  ApiGetUploadedFilesNoType,
  ApiSaveUploadedFiles,
  ApiDeleteFile,
  ApiGetTypeOptions,
  ApiCreateExecution,
  ApiGetExecution,
  ApiGetDocumentTypes,
  ApiPostDocumentType,
  ApiGetDocumentsByType as ApiGetDocumentsByType,
  ApiPostDLMTag,
  ApiPutDLMTag,
  ApiGetDLMTags,
  ApiPostDLMWorkflow,
  ApiGetDLMWorkflow,
  ApiPostDLMTagDocument,
  ApiGetDLMListKeyword,
  ApiPostDLMKeyword,
  ApiPostDLMKeywordDocument,
  ApiPostDLMValidateTag,
  ApiDeleteDLMDoc,
  ApiDeleteDLMKeyword,
  ApiPostDLMTagWarning,
  ApiPutDLMTagWarning,
  ApiPutDLMUpdateTagWorkflow,
  ApiGetDLMTagWarning,
  ApiDeleteDLMTag,
  ApiDeleteDLMTagWorkflow,
  ApiPostDLMDocumentVersion,
  ApiPutDocumentApproval,
  ApiPostNewDocument,
  ApiPostDLMAttachDocuments,
  ApiDeleteDLMAttachDocuments,
  ApiPostDLMValidateTagEmail,
  ApiPostDLMAttachFiles,
  ApiUpoloadFlightData,
  ApiUpoloadPriceReport,
  ApiGetReconciliationData,
  ApiPostReconAnnotations,
  ApiGetReconAnnotations,
  ApiPutReconAnnotations,
  ApiDeleteReconAnnotations,
  ApiChatGptDlmSummary,
  ApiPostChatGptDLMQuestion,
  ApiPostChatGptDLMResponse,
  ApiPostDLMDepartment,
  ApiGetDLMDepartment,
  ApiPutDLMDepartment,
  ApiPutDLMDocumentType,
  ApiPostDLMNewDocumentFeild,
  ApiGetDLMDocumentField,
  ApiPutDLMDocumentFeild,
  ApiDeleteDLMDocumentFeild,
  ApiPostDLMDocTypeFields,
  ApiGetDLMDocTypeFields,
  ApiPutDLMDocTypeFields,
  ApiDeleteDLMDocTypeFields,
  ApiDeleteDLMDepartment,
  ApiDeleteDLMDocType,
  ApiPostDLMDocTypeValidValues,
  ApiGetDLMDocTypeValidValues,
  ApiPutDLMDocTypeValidValues,
  ApiDeleteDLMDocTypeValidValues,
  ApiPostDLMConfidentiality,
  ApiGetDLMConfidentiality,
  ApiDeleteDLMConfidentiality,
  ApiPostDLMUsersAccesses,
  ApiGetDLMUsersAccesses,
  ApiDeleteDLMUsersAccesses,
  ApiPutDLMUsersAccesses,
  ApiPostCreateAccount,
  ApiGetListAccount,
  ApiUpdateAccount,
  ApiDeleteAccount,
  ApiPostCreateBank,
  ApiGetListBank,
  ApiUpdateBank,
  ApiDeleteBank,
  ApiGetListExtract,
  ApiDeleteExtract,
  ApiGetListCategory,
  ApiPostCreateCategory,
  ApiUpdateCategory,
  ApiDeleteCategory,
  ApiGetListLancamento,
  ApiPostCreateLancamento,
  ApiUpdateLancamento,
  ApiDeleteLancamento,
  ApiGetListConciliacao,
  ApiGetListSimulacao,
  ApiUpdateVincMovimentacao,
  ApiUpdateDesvincMovimentacao,
  ApiGetListSimulacaoConta,
  ApiPostCreateLancamentoConciliacao,
  ApiGetExecuteConciliacao,
  ApiGetGestaoFinanceiraContato,
  ApiGetExtractMovements,
  ApiGetValidateExtract,
  ApiGetTransferenciaConta,
  ApiPostTransferenciaConta,
  ApiGetLevdataEmpresaInfo,
  ApiGetLevdataImpostos,
  ApiGetLevdataMargem,
  ApiGetLevdataSituacaoTributaria,
  ApiGetLevdataLevNotas,
  ApiGetLevdataReceita,
  ApiGetLevdataHistoricoDashboard,
  ApiGetLevdataLimiteUtilizado,
  ApiGetLevdataRegimeAtual,
  ApiGetLevdataAliquotaAtual,
  ApiGetLevdataDespesas,
  ApiGetLevdataCreditoPotencial,
  ApiGetLevdataComprasSemCredito,
  ApiGetLevdataDetalhamentoLucro,
  ApiGetLevdataCreditosFiscais,
  ApiGetLevdataFornecedorPorCredito,
  ApiGetLevdataSemCreditoPotencial,
  ApiGetLevdataCreditoPisCofins,
  ApiGetLevdataHistoricoCreditos,
  ApiGetLevdataDashboardInsights,
  ApiGetFinanceiroDashboardProdutos,
  ApiGetFinanceiroDashboardClientes,
  ApiGetFinanceiroDashboardMotorInsights,
  ApiGetLevdataCenarioVendas,
  ApiGetLevdataCreditosPotenciaisInsights,
  ApiGetLevdataRegimeTributarioSimulacao,
  ApiGetLevdataRegimeTributarioComparativo,
  ApiGetLevdataRegimeTributarioMotorExecutivo,
  ApiPostLevdataPrecificacaoNotaValor,
  ApiGetLevdataPrecificacaoProdutoNfe,
  ApiGetLevdataPrecificacaoProdutoNfse,
  ApiPostLevdataPrecificacaoCombinarProduto,
  ApiPostLevdataPrecificacaoCombinarServico,
  ApiGetLevdataPrecificacaoFavoritos,
  ApiPostLevdataPrecificacaoToggleFavorito,
  ApiGetLevdataPrecificacaoSimulacaoProduto,
  ApiGetLevdataPrecificacaoCalculoCenario,
  ApiGetLevdataPrecificacaoCalculoTributario,
  ApiGetLevdataPrecificacaoHistorico,
  ApiGetTabelaBc,
  ApiGetListaCnae,
  ApiUpdateCnaeIdBc,
  ApiCreateTabelaBc,
  ApiUpdateTabelaBc,
  ApiDeleteTabelaBc,
  ApiUpdateCnae,
  ApiDeleteCnae,
  ApiCreateCnae
} from './subidaDeDocumentos.api';
import { createAction } from '@reduxjs/toolkit';

export const resetDLMDocTypeId = createAction('dlm/resetdoctypeid');

export const recordDLMDocTypeData = createAction(
  'dlm/recorddoctypeid',
  (data) => ({
    payload: data
  })
);

export const recordDLMDocsSelected = createAction(
  'dlm/recorddocsselected',
  (data) => ({
    payload: data
  })
);
//usada

export const recordDLMDocVersionData = createAction(
  'dlm/recorddocversiondata',
  (data) => ({
    payload: data
  })
);

export const getUploadedFiles = createAsyncThunk(
  'api/files',
  async ({
    id,
    nota_type,
    type,
    error_message,
    file_name,
    page,
    per_page,
    data_inicio,
    data_fim
  }) => {
    let response = await ApiGetUploadedFiles({
      id,
      nota_type,
      type,
      error_message,
      file_name,
      page,
      per_page,
      data_inicio,
      data_fim
    });
    return response;
  }
);

export const getUploadedFilesNoType = createAsyncThunk(
  'api/allfiles',
  async ({ id, page, per_page }) => {
    let response = await ApiGetUploadedFilesNoType({
      id,
      page,
      per_page
    });
    return response;
  }
);

export const getTypeOptions = createAsyncThunk('api/types', async (id) => {
  let response = await ApiGetTypeOptions(id);
  return response;
});

export const saveUploadedFiles = createAsyncThunk(
  'api/save',
  async (saveData) => {
    let response = await ApiSaveUploadedFiles(saveData);
    return response;
  }
);

export const deleteUploadedFiles = createAsyncThunk(
  'api/delete',
  async (ids) => {
    let response = await ApiDeleteFile(ids);
    return response;
  }
);

export const createExecution = createAsyncThunk(
  'api/createexec',
  async (executionData) => {
    let response = await ApiCreateExecution(executionData);
    return response;
  }
);

export const getExecution = createAsyncThunk('api/getexec', async (id) => {
  let response = await ApiGetExecution(id);
  return response;
});

// DLM Document Lifecycle Manager
export const postDocumentType = createAsyncThunk(
  'api/postdlmdocumenttype',
  async ({ company_id, group_id, extensao, nome, sigla }) => {
    let response = await ApiPostDocumentType({
      company_id,
      group_id,
      extensao,
      nome,
      sigla
    });
    return response;
  }
);

export const getDocumentTypes = createAsyncThunk(
  'api/getdlmdocumenttypes',
  async (groupId) => {
    let response = await ApiGetDocumentTypes(groupId);
    return response;
  }
);

export const postDLMDocument = createAsyncThunk(
  'api/postnewdlmdocument',
  async ({ key, document_type_id, descricao }) => {
    let response = await ApiPostNewDocument({
      key,
      document_type_id,
      descricao
    });
    return response;
  }
);

export const getDocumentsByType = createAsyncThunk(
  'api/getdlmdocumentsbytype',
  async ({ document_type_id, page, per_page }) => {
    let response = await ApiGetDocumentsByType({
      document_type_id,
      page,
      per_page
    });
    return response;
  }
);

export const getDocsByTypeForAttach = createAsyncThunk(
  'api/getdlmdocsbytypeforattach',
  async (document_type_id, page, per_page) => {
    let response = await ApiGetDocumentsByType(
      document_type_id,
      page,
      per_page
    );
    return response;
  }
);

export const deleteDLMDoc = createAsyncThunk('api/deletedlmdoc', async (id) => {
  let response = await ApiDeleteDLMDoc(id);
  return response;
});

// attach tags
export const postDLMTagDocument = createAsyncThunk(
  'api/postdlmtagdocument',
  async ({ document_id, tag_id }) => {
    let response = await ApiPostDLMTagDocument({
      document_id,
      tag_id
    });
    return response;
  }
);

export const postDLMValidateTag = createAsyncThunk(
  'api/postdlmvalidatetag',
  async ({
    tag_id,
    document_type_id,
    document_id,
    validation,
    alerta,
    data_necessidade
  }) => {
    let response = await ApiPostDLMValidateTag({
      tag_id,
      document_type_id,
      document_id,
      validation,
      alerta,
      data_necessidade
    });
    return response;
  }
);

export const postDLMKeyword = createAsyncThunk(
  'api/postdlmkeyword',
  async () => {
    let response = await ApiPostDLMKeyword();
    return response;
  }
);

export const getDLMKeywords = createAsyncThunk(
  'api/getdlmkeywords',
  async ({ page, per_page }) => {
    let response = await ApiGetDLMListKeyword({
      page,
      per_page
    });
    return response;
  }
);

// attach keyword
export const postDLMKeywordDocument = createAsyncThunk(
  'api/postdlmkeyworddocument',
  async () => {
    let response = await ApiPostDLMKeywordDocument();
    return response;
  }
);

export const deleteDLMKeyword = createAsyncThunk(
  'api/deletedlmkeyword',
  async (id) => {
    let response = await ApiDeleteDLMKeyword(id);
    return response;
  }
);

export const postDLMDocumentVersion = createAsyncThunk(
  'api/postdlmdocversion',
  async ({ key, latest_document_id, versao }) => {
    let response = await ApiPostDLMDocumentVersion({
      key,
      latest_document_id,
      versao
    });
    return response;
  }
);

export const putDLMDocumentApproval = createAsyncThunk(
  'api/putdlmdocapproval',
  async ({ document_id, status, alerta, data_necessidade }) => {
    let response = await ApiPutDocumentApproval({
      document_id,
      status,
      alerta,
      data_necessidade
    });
    return response;
  }
);

export const postDLMValidateTagEmail = createAsyncThunk(
  'api/postdlmvalidatetagemail',
  async ({ list_emails, email_subject, email_body }) => {
    let response = await ApiPostDLMValidateTagEmail({
      list_emails,
      email_subject,
      email_body
    });
    return response;
  }
);

// DLM Document Lifecycle Manager Workflow
export const postDLMTag = createAsyncThunk(
  'api/postdlmtag',
  async ({ name, color, company_id, document_type_id, alerta }) => {
    let response = await ApiPostDLMTag({
      name,
      color,
      company_id,
      document_type_id,
      alerta
    });
    return response;
  }
);

export const putDLMTag = createAsyncThunk(
  'api/putdlmtag',
  async ({ id, name, color, alert }) => {
    let response = await ApiPutDLMTag({
      id,
      name,
      color,
      alert
    });
    return response;
  }
);

export const getDLMTags = createAsyncThunk(
  'api/getdlmtags',
  async (document_type_id) => {
    let response = await ApiGetDLMTags(document_type_id);
    return response;
  }
);

export const deleteDLMTag = createAsyncThunk('api/deletedlmtag', async (id) => {
  let response = await ApiDeleteDLMTag(id);
  return response;
});

export const postDLMWorkflow = createAsyncThunk(
  'api/postdlmworkflow',
  async ({ document_type_id, tag_orig_id, tag_dest_id, validation }) => {
    let response = await ApiPostDLMWorkflow({
      document_type_id,
      tag_orig_id,
      tag_dest_id,
      validation
    });
    return response;
  }
);

export const getDLMWorkflow = createAsyncThunk(
  'api/getdlmworkflow',
  async (document_type_id) => {
    let response = await ApiGetDLMWorkflow(document_type_id);
    return response;
  }
);

export const deleteDLMTagWorkflow = createAsyncThunk(
  'api/deletedlmworkflow',
  async (id) => {
    let response = await ApiDeleteDLMTagWorkflow(id);
    return response;
  }
);

export const postDLMTagWarning = createAsyncThunk(
  'api/postdlmtagwarning',
  async ({ tag_id, email, aviso }) => {
    let response = await ApiPostDLMTagWarning({ tag_id, email, aviso });
    return response;
  }
);

export const putDLMTagWarning = createAsyncThunk(
  'api/putdlmtagwarning',
  async ({ id, email, aviso }) => {
    let response = await ApiPutDLMTagWarning({ id, email, aviso });
    return response;
  }
);

export const putDLMUpdateTagWorkflow = createAsyncThunk(
  'api/putdlmupdatetagworkflow',
  async ({ id, id_tag_orig, id_tag_dest }) => {
    let response = await ApiPutDLMUpdateTagWorkflow({
      id,
      id_tag_orig,
      id_tag_dest
    });
    return response;
  }
);

export const getDLMTagWarning = createAsyncThunk(
  'api/getdlmtagwarning',
  async (tag_id) => {
    let response = await ApiGetDLMTagWarning(tag_id);
    return response;
  }
);

// Anexos
export const postDLMAttachDocuments = createAsyncThunk(
  'api/postdlmattachdocuments',
  async ({ id_documento, id_anexo }) => {
    let response = await ApiPostDLMAttachDocuments({
      id_documento,
      id_anexo
    });
    return response;
  }
);

export const deleteDLMAttachDocuments = createAsyncThunk(
  'api/deletedlmattachdocuments',
  async (idAnexo) => {
    let response = await ApiDeleteDLMAttachDocuments(idAnexo);
    return response;
  }
);

export const postDLMAttachFiles = createAsyncThunk(
  'api/postdlmattachfiles',
  async ({ id_documento, key }) => {
    let response = await ApiPostDLMAttachFiles({
      id_documento,
      key
    });
    return response;
  }
);

export const postFightData = createAsyncThunk(
  'api/uploadflightdata',
  async ({ file_name }) => {
    let response = await ApiUpoloadFlightData({ file_name });
    return response;
  }
);

export const postPriceReportData = createAsyncThunk(
  'api/uploadpricereport',
  async ({ file_name }) => {
    let response = await ApiUpoloadPriceReport({ file_name });
    return response;
  }
);

//Reconciliation
export const getReconciliationData = createAsyncThunk(
  'api/getreconciliationdata',
  async ({
    page,
    per_page,
    filter_type,
    flight_number,
    item_name,
    start_date,
    end_date
  }) => {
    let response = await ApiGetReconciliationData({
      page,
      per_page,
      filter_type,
      flight_number,
      item_name,
      start_date,
      end_date
    });
    return response;
  }
);

export const postReconAnnotations = createAsyncThunk(
  'api/postreconannotations',
  async ({ reconciliation_id, annotation, status }) => {
    let response = await ApiPostReconAnnotations({
      reconciliation_id,
      annotation,
      status
    });
    return response;
  }
);

export const getReconAnnotations = createAsyncThunk(
  'api/getreconannotations',
  async (reconciliation_id) => {
    let response = ApiGetReconAnnotations(reconciliation_id);
    return response;
  }
);

export const putReconAnnotations = createAsyncThunk(
  'api/putreconannotations',
  async ({ annotation_id, status }) => {
    let response = await ApiPutReconAnnotations({
      annotation_id,
      status
    });
    return response;
  }
);

export const deleteReconAnnotations = createAsyncThunk(
  'api/putreconannotations',
  async ({ annotation_id }) => {
    let response = await ApiDeleteReconAnnotations({
      annotation_id
    });
    return response;
  }
);

//ChatGPTDLM
export const postChatGptDlmSummary = createAsyncThunk(
  'api/postchatgptdlmsummary',
  async ({ bucket_name, folder_name }) => {
    let response = await ApiChatGptDlmSummary({ bucket_name, folder_name });
    return response;
  }
);

export const postChatGptDLMQuestion = createAsyncThunk(
  'api/chatgptresponse',
  async ({ bucket_name, folder_name, list_files, pergunta }) => {
    let response = await ApiPostChatGptDLMQuestion({
      bucket_name,
      folder_name,
      list_files,
      pergunta
    });
    return response;
  }
);

export const postChatGptDLMResponse = createAsyncThunk(
  'api/chatgptresponse',
  async ({ bucket_name, folder_name, list_files, pergunta }) => {
    let response = await ApiPostChatGptDLMResponse({
      bucket_name,
      folder_name,
      list_files,
      pergunta
    });
    return response;
  }
);

// Departamento
export const postDLMDepartment = createAsyncThunk(
  'api/postdlmdepartment',
  async ({ company_id, name }) => {
    let response = await ApiPostDLMDepartment({
      company_id,
      name
    });
    return response;
  }
);

export const putDLMDepartment = createAsyncThunk(
  'api/putdlmdepartment',
  async ({ group_id, name }) => {
    let response = await ApiPutDLMDepartment({
      group_id,
      name
    });
    return response;
  }
);

export const putDLMDocumentType = createAsyncThunk(
  'api/putdlmdoctype',
  async ({ document_type_id, name, acronym, extension }) => {
    let response = await ApiPutDLMDocumentType({
      document_type_id,
      name,
      acronym,
      extension
    });
    return response;
  }
);

export const deleteDLMDepartment = createAsyncThunk(
  'api/deletedlmdepartment',
  async (department_id) => {
    let response = await ApiDeleteDLMDepartment(department_id);
    return response;
  }
);

export const deleteDLMDocType = createAsyncThunk(
  'api/deletedlmdoctype',
  async (document_type_id) => {
    let response = await ApiDeleteDLMDocType(document_type_id);
    return response;
  }
);

export const getDLMDepartment = createAsyncThunk(
  'api/getdlmdepartment',
  async (cnpj) => {
    let response = await ApiGetDLMDepartment(cnpj);
    return response;
  }
);
// Document Feild
export const postDLMNewDocumentFeild = createAsyncThunk(
  'api/postdlmnewdocumentfeild',
  async ({ document_id, field_name, field_type, size, value }) => {
    let response = await ApiPostDLMNewDocumentFeild({
      document_id,
      field_name,
      field_type,
      size,
      value
    });
    return response;
  }
);

export const getDLMDocumentField = createAsyncThunk(
  'api/getdlmdedocumentfield',
  async (document_id) => {
    let response = await ApiGetDLMDocumentField(document_id);
    return response;
  }
);

export const putDLMDocumentFeild = createAsyncThunk(
  'api/putdlmdocumentFeild',
  async ({ id, field_name, field_type, size, value, mission }) => {
    let response = await ApiPutDLMDocumentFeild({
      id,
      field_name,
      field_type,
      size,
      value,
      mission
    });
    return response;
  }
);

export const deleteDLMDocumentsFeild = createAsyncThunk(
  'api/deletedlmdocumentsfeild',
  async (documentFieldId) => {
    console.log('store', documentFieldId);
    let response = await ApiDeleteDLMDocumentFeild(documentFieldId);
    return response;
  }
);

// Document Type Field
export const postDLMDLMDocTypeFields = createAsyncThunk(
  'api/postdlmnewdocumentfeild',
  async ({ document_type_id, field_name, field_type, size }) => {
    let response = await ApiPostDLMDocTypeFields({
      document_type_id,
      field_name,
      field_type,
      size
    });
    return response;
  }
);

export const getDLMDocTypeFields = createAsyncThunk(
  'api/getdlmdedocumentfield',
  async (document_type_id) => {
    let response = await ApiGetDLMDocTypeFields(document_type_id);
    return response;
  }
);

export const putDLMDocTypeFields = createAsyncThunk(
  'api/putdlmdocumentFeild',
  async ({ id, field_name, field_type, size }) => {
    let response = await ApiPutDLMDocTypeFields({
      id,
      field_name,
      field_type,
      size
    });
    return response;
  }
);

export const deleteDLMDocTypeFields = createAsyncThunk(
  'api/deletedlmdocumentsfeild',
  async (id) => {
    let response = await ApiDeleteDLMDocTypeFields(id);
    return response;
  }
);

// Document Type Valid Values
export const postDLMDocTypeValidValues = createAsyncThunk(
  'api/postdlmdoctypevalidvalues',
  async ({ id_type_document_field, value }) => {
    let response = await ApiPostDLMDocTypeValidValues({
      id_type_document_field,
      value
    });
    return response;
  }
);

export const getDLMDocTypeValidValues = createAsyncThunk(
  'api/getdlmdoctypevalidvalues',
  async (id_type_document_field) => {
    let response = await ApiGetDLMDocTypeValidValues(id_type_document_field);
    return response;
  }
);

export const putDLMDocTypeValidValues = createAsyncThunk(
  'api/putdlmdoctypevalidvalues',
  async ({ id, value }) => {
    let response = await ApiPutDLMDocTypeValidValues({
      id,
      value
    });
    return response;
  }
);

export const deleteDLMDocTypeValidValues = createAsyncThunk(
  'api/deletedlmdoctypevalidvalues',
  async (id) => {
    let response = await ApiDeleteDLMDocTypeValidValues(id);
    return response;
  }
);

//DLM Confidencialidade
export const postDLMConfidentiality = createAsyncThunk(
  'api/postdlmconfidentiality',
  async ({ company_id, degree, description }) => {
    let response = await ApiPostDLMConfidentiality({
      company_id,
      degree,
      description
    });
    return response;
  }
);

export const getDLMConfidentiality = createAsyncThunk(
  'api/getdlmconfidentiality',
  async (cnpj) => {
    let response = await ApiGetDLMConfidentiality(cnpj);
    return response;
  }
);

export const deleteDLMConfidentiality = createAsyncThunk(
  'api/deletedlmconfidentiality',
  async (id) => {
    let response = await ApiDeleteDLMConfidentiality(id);
    return response;
  }
);

//DLM Acessos de usuários
export const postDLMUsersAccesses = createAsyncThunk(
  'api/postdlmusersaccesses',
  async ({ user_id, document_type_id, access_type, max_degree }) => {
    let response = await ApiPostDLMUsersAccesses({
      user_id,
      document_type_id,
      access_type,
      max_degree
    });
    return response;
  }
);

export const getDLMUsersAccesses = createAsyncThunk(
  'api/getdlmusersaccesses',
  async (user_id) => {
    let response = await ApiGetDLMUsersAccesses(user_id);
    return response;
  }
);

export const deleteDLMUsersAccesses = createAsyncThunk(
  'api/deletedlmusersaccesses',
  async (id) => {
    let response = await ApiDeleteDLMUsersAccesses(id);
    return response;
  }
);

export const putDLMUsersAccesses = createAsyncThunk(
  'api/putdlmusersaccesses',
  async ({ id, access_type, max_degree }) => {
    let response = await ApiPutDLMUsersAccesses({
      id,
      access_type,
      max_degree
    });
    return response;
  }
);

//GESTÃO FINANCEIRA - LEVDATA
export const postCreateAccount = createAsyncThunk(
  'api/postcreateaccount',
  async ({
    IdEmpresa,
    Codgbanco,
    Nomebanco,
    Agencia,
    Numrconta,
    Tipoconta,
    Nomeconta,
    Situacao,
    SaldoInicial,
    DataSaldoInicial
  }) => {
    let response = await ApiPostCreateAccount({
      IdEmpresa,
      Codgbanco,
      Nomebanco,
      Agencia,
      Numrconta,
      Tipoconta,
      Nomeconta,
      Situacao,
      SaldoInicial,
      DataSaldoInicial
    });
    return response;
  }
);

export const getListAccount = createAsyncThunk(
  'api/getlistaccount',
  async ({ IdEmpresa, Nomeconta, Nomebanco, Situacao }) => {
    let response = await ApiGetListAccount({
      IdEmpresa,
      Nomeconta,
      Nomebanco,
      Situacao
    });
    return response;
  }
);

export const putUpdateAccount = createAsyncThunk(
  'api/putupdateaccount',
  async ({
    id,
    IdEmpresa,
    Nomeconta,
    Situacao,
    SaldoAtual,
    Codgbanco,
    Nomebanco,
    Agencia,
    Numrconta,
    Tipoconta,
    DataSaldoAtual,
    Motivo
  }) => {
    let response = await ApiUpdateAccount({
      id,
      IdEmpresa,
      Nomeconta,
      Situacao,
      SaldoAtual,
      Codgbanco,
      Nomebanco,
      Agencia,
      Numrconta,
      Tipoconta,
      DataSaldoAtual,
      Motivo
    });
    return response;
  }
);

export const deleteAccount = createAsyncThunk(
  'api/deleteaccount',
  async (id) => {
    let response = await ApiDeleteAccount(id);
    return response;
  }
);

export const postCreateBank = createAsyncThunk(
  'api/postcreatebank',
  async ({ name, code }) => {
    let response = await ApiPostCreateBank({
      name,
      code
    });
    return response;
  }
);

export const getListBank = createAsyncThunk('api/getlistbank', async () => {
  let response = await ApiGetListBank();
  return response;
});

export const putUpdateBank = createAsyncThunk(
  'api/putupdatebank',
  async ({ id, name, code }) => {
    let response = await ApiUpdateBank({
      id,
      name,
      code
    });
    return response;
  }
);

export const deleteBank = createAsyncThunk('api/deletebank', async (id) => {
  let response = await ApiDeleteBank(id);
  return response;
});

export const getListExtract = createAsyncThunk(
  'api/getlistextract',
  async ({ Id, DataInicio, DataFim, Documento, Categoria, Acao, Status }) => {
    let response = await ApiGetListExtract({
      Id,
      DataInicio,
      DataFim,
      Documento,
      Categoria,
      Acao,
      Status
    });
    return response;
  }
);

export const deleteExtract = createAsyncThunk(
  'api/deleteextract',
  async (Id) => {
    let response = await ApiDeleteExtract(Id);
    return response;
  }
);

export const getListCategory = createAsyncThunk(
  'api/getlistcategory',
  async ({ IdEmpresa, Nome, Tipo, CatgPrincipal }) => {
    let response = await ApiGetListCategory({
      IdEmpresa,
      Nome,
      Tipo,
      CatgPrincipal
    });
    return response;
  }
);

export const postCreateCategory = createAsyncThunk(
  'api/postcreatecategory',
  async ({ IdEmpresa, Nome, Tipo, CatgPrincipal, Descricao, CalculaCusto }) => {
    let response = await ApiPostCreateCategory({
      IdEmpresa,
      Nome,
      Tipo,
      CatgPrincipal,
      Descricao,
      CalculaCusto
    });
    return response;
  }
);

export const putUpdateCategory = createAsyncThunk(
  'api/putupdatecategory',
  async ({ Id, Nome, Tipo, CatgPrincipal, Descricao, CalculaCusto }) => {
    let response = await ApiUpdateCategory({
      Id,
      Nome,
      Tipo,
      CatgPrincipal,
      Descricao,
      CalculaCusto
    });
    return response;
  }
);

export const deleteCategory = createAsyncThunk(
  'api/deletecategory',
  async (id) => {
    let response = await ApiDeleteCategory(id);
    return response;
  }
);

export const getListLancamento = createAsyncThunk(
  'api/getlistlancamento',
  async ({
    IdEmpresa,
    DateInit,
    DateFim,
    Tipo,
    IdCategoria,
    page,
    per_page
  }) => {
    let response = await ApiGetListLancamento({
      IdEmpresa,
      DateInit,
      DateFim,
      Tipo,
      IdCategoria,
      page,
      per_page
    });
    return response;
  }
);

export const postCreateLancamento = createAsyncThunk(
  'api/postcreatelancamento',
  async ({
    IdEmpresa,
    DataLancamento,
    DataVencimento,
    Contato,
    IdCategoria,
    Detalhamento,
    Valor,
    TipoLancamento,
    Rateio
  }) => {
    let response = await ApiPostCreateLancamento({
      IdEmpresa,
      DataLancamento,
      DataVencimento,
      Contato,
      IdCategoria,
      Detalhamento,
      Valor,
      TipoLancamento,
      Rateio
    });
    return response;
  }
);

export const putUpdatelancamento = createAsyncThunk(
  'api/putupdatelancamento',
  async ({
    Id,
    DataLancamento,
    DataVencimento,
    Contato,
    IdCategoria,
    Detalhamento,
    Valor,
    TipoLancamento,
    Rateio
  }) => {
    let response = await ApiUpdateLancamento({
      Id,
      DataLancamento,
      DataVencimento,
      Contato,
      IdCategoria,
      Detalhamento,
      Valor,
      TipoLancamento,
      Rateio
    });
    return response;
  }
);

export const deleteLancamento = createAsyncThunk(
  'api/deletelancamento',
  async (id) => {
    let response = await ApiDeleteLancamento(id);
    return response;
  }
);

export const getListConciliacao = createAsyncThunk(
  'api/getlistconciliacao',
  async ({ IdConta, Status, Tipo, Historico, NumeroConta, page, per_page }) => {
    let response = await ApiGetListConciliacao({
      IdConta,
      Status,
      Tipo,
      Historico,
      NumeroConta,
      page,
      per_page
    });
    return response;
  }
);

export const getListSimulacao = createAsyncThunk(
  'api/getlistsimulacao',
  async ({ IdEmpresa }) => {
    let response = await ApiGetListSimulacao({
      IdEmpresa
    });
    return response;
  }
);

export const putUpdateVincMovimentacao = createAsyncThunk(
  'api/putupdatevincmovimentacao',
  async ({ Id, IdLancamento, IdCategoria, Status, Ids }) => {
    let response = await ApiUpdateVincMovimentacao({
      Id,
      IdLancamento,
      IdCategoria,
      Status,
      Ids
    });
    return response;
  }
);

export const putUpdateDesvincMovimentacao = createAsyncThunk(
  'api/putupdatedesvincmovimentacao',
  async ({ Id, Ids }) => {
    let response = await ApiUpdateDesvincMovimentacao({
      Id,
      Ids
    });
    return response;
  }
);

export const getListSimulacaoConta = createAsyncThunk(
  'api/getlistsimulacaoconta',
  async ({ IdEmpresa, IdConta, year, month, page, per_page }) => {
    let response = await ApiGetListSimulacaoConta({
      IdEmpresa,
      IdConta,
      year,
      month,
      page,
      per_page
    });
    return response;
  }
);

export const postCreateLancamentoConciliacao = createAsyncThunk(
  'api/postcreatelancamentoconciliacao',
  async ({
    IdMovimentacao,
    IdEmpresa,
    DataLancamento,
    DataVencimento,
    Contato,
    IdCategoria,
    Detalhamento,
    Valor,
    TipoLancamento
  }) => {
    let response = await ApiPostCreateLancamentoConciliacao({
      IdMovimentacao,
      IdEmpresa,
      DataLancamento,
      DataVencimento,
      Contato,
      IdCategoria,
      Detalhamento,
      Valor,
      TipoLancamento
    });
    return response;
  }
);

export const getExecuteConciliacao = createAsyncThunk(
  'api/getexecuteconciliacao',
  async ({ IdConta }) => {
    let response = await ApiGetExecuteConciliacao({
      IdConta
    });
    return response;
  }
);

export const getGestaoFinanceiraContato = createAsyncThunk(
  'api/getgestaofinanceiracontato',
  async ({ IdEmpresa }) => {
    let response = await ApiGetGestaoFinanceiraContato({
      IdEmpresa
    });
    return response;
  }
);

export const getExtractMovements = createAsyncThunk(
  'api/getextractmovements',
  async ({
    ExtractId,
    page,
    per_page,
    DataInicio,
    DataFim,
    Documento,
    Categoria,
    Acao,
    Status
  }) => {
    let response = await ApiGetExtractMovements({
      ExtractId,
      page,
      per_page,
      DataInicio,
      DataFim,
      Documento,
      Categoria,
      Acao,
      Status
    });
    return response;
  }
);

export const getValidateExtract = createAsyncThunk(
  'api/getvalidateextract',
  async ({ extrato_key }) => {
    let response = await ApiGetValidateExtract({
      extrato_key
    });
    return response;
  }
);

export const getTransferenciaConta = createAsyncThunk(
  'api/gettransferenciaconta',
  async ({ IdConta, IdMovimentacao, DataMovimento, ValorMovimento }) => {
    let response = await ApiGetTransferenciaConta({
      IdConta,
      IdMovimentacao,
      DataMovimento,
      ValorMovimento
    });
    return response;
  }
);

export const getLevdataEmpresaInfo = createAsyncThunk(
  'api/getlevdataempresainfo',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataEmpresaInfo({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataImpostos = createAsyncThunk(
  'api/getlevdataimpostos',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataImpostos({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataMargem = createAsyncThunk(
  'api/getlevdatamargem',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataMargem({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataSituacaoTributaria = createAsyncThunk(
  'api/getlevdatasituacaotributaria',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataSituacaoTributaria({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataLevNotas = createAsyncThunk(
  'api/getlevdatalevnotas',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataLevNotas({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataReceita = createAsyncThunk(
  'api/getlevdatareceita',
  async ({ Cnpj, TipoNota, RN, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataReceita({
      Cnpj,
      TipoNota,
      RN,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataHistoricoDashboard = createAsyncThunk(
  'api/getlevdatahistoricodashboard',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Meses, Silent }) => {
    let response = await ApiGetLevdataHistoricoDashboard({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Meses,
      Silent
    });
    return response;
  }
);

// Mesmo endpoint de getLevdataReceita, mas com estado próprio (ENTRADA/compras)
// para não colidir com listLevdataReceita (SAIDA/receita) usado no Dashboard.
export const getLevdataComprasEntrada = createAsyncThunk(
  'api/getlevdatacomprasentrada',
  async ({
    Cnpj,
    TipoNota = 'ENTRADA',
    RN = 0,
    Ano,
    Mes,
    DataInicio,
    DataFim,
    Silent
  }) => {
    let response = await ApiGetLevdataReceita({
      Cnpj,
      TipoNota,
      RN,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataLimiteUtilizado = createAsyncThunk(
  'api/getlevdatalimiteutilizado',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataLimiteUtilizado({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataRegimeAtual = createAsyncThunk(
  'api/getlevdataregimeatual',
  async ({ Cnpj, Silent }) => {
    let response = await ApiGetLevdataRegimeAtual({
      Cnpj,
      Silent
    });
    return response;
  }
);

export const getLevdataAliquotaAtual = createAsyncThunk(
  'api/getlevdataaliquotaatual',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataAliquotaAtual({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataDespesas = createAsyncThunk(
  'api/getlevdatadespesas',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, SemImpostos, Silent }) => {
    let response = await ApiGetLevdataDespesas({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      SemImpostos,
      Silent
    });
    return response;
  }
);

// Mesmos endpoints de receita/despesas, mas com estado próprio (Diagnóstico) para
// não colidir com listLevdataReceita/listLevdataDespesas (mês atual) usados no
// Dashboard — o Diagnóstico busca sempre o mês anterior, com Ano/Mes diferentes.
export const getLevdataReceitaDiagnostico = createAsyncThunk(
  'api/getlevdatareceitadiagnostico',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataReceita({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataDespesasDiagnostico = createAsyncThunk(
  'api/getlevdatadespesasdiagnostico',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataDespesas({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

// Mesma justificativa de Receita/Despesas acima: o card "Crédito Potencial"
// do Dashboard e o Diagnóstico consultam o MESMO endpoint com períodos
// diferentes. Sem estado próprio, abrir o Diagnóstico sobrescrevia o valor
// do card do Dashboard (e piscava o spinner dele) com o dado do mês
// anterior, e vice-versa.
export const getLevdataCreditoPotencialDiagnostico = createAsyncThunk(
  'api/getlevdatacreditopotencialdiagnostico',
  async ({ Cnpj, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataCreditoPotencial({
      Cnpj,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataCreditoPotencial = createAsyncThunk(
  'api/getlevdatacreditopotencial',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataCreditoPotencial({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataComprasSemCredito = createAsyncThunk(
  'api/getlevdatacomprassemcredito',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataComprasSemCredito({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataDetalhamentoLucro = createAsyncThunk(
  'api/getlevdatadetalhamentolucro',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataDetalhamentoLucro({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataCreditosFiscais = createAsyncThunk(
  'api/getlevdatacreditosfiscais',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataCreditosFiscais({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataFornecedorPorCredito = createAsyncThunk(
  'api/getlevdatafornecedorporcredito',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataFornecedorPorCredito({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataSemCreditoPotencial = createAsyncThunk(
  'api/getlevdatasemcreditopotencial',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataSemCreditoPotencial({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataCreditoPisCofins = createAsyncThunk(
  'api/getlevdatacreditopiscofins',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataCreditoPisCofins({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataHistoricoCreditos = createAsyncThunk(
  'api/getlevdatahistoricocreditos',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Meses, Silent }) => {
    let response = await ApiGetLevdataHistoricoCreditos({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Meses,
      Silent
    });
    return response;
  }
);

export const getLevdataDashboardInsights = createAsyncThunk(
  'api/getlevdatadashboardinsights',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataDashboardInsights({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getFinanceiroDashboardProdutos = createAsyncThunk(
  'api/getfinanceirodashboardprodutos',
  async ({
    Cnpj,
    Ano,
    Mes,
    Produto,
    DataInicio,
    DataFim,
    Origem,
    Page,
    PerPage,
    Silent
  }) => {
    let response = await ApiGetFinanceiroDashboardProdutos({
      Cnpj,
      Ano,
      Mes,
      Produto,
      DataInicio,
      DataFim,
      Origem,
      Page,
      PerPage,
      Silent
    });
    return response;
  }
);

export const getFinanceiroDashboardClientes = createAsyncThunk(
  'api/getfinanceirodashboardclientes',
  async ({
    Cnpj,
    Ano,
    Mes,
    Cliente,
    DataInicio,
    DataFim,
    Origem,
    Page,
    PerPage,
    Silent
  }) => {
    let response = await ApiGetFinanceiroDashboardClientes({
      Cnpj,
      Ano,
      Mes,
      Cliente,
      DataInicio,
      DataFim,
      Origem,
      Page,
      PerPage,
      Silent
    });
    return response;
  }
);

export const getFinanceiroDashboardMotorInsights = createAsyncThunk(
  'api/getfinanceirodashboardmotorinsights',
  async ({
    Cnpj,
    Ano,
    Mes,
    DataInicio,
    DataFim,
    Origem,
    Page,
    PerPage,
    Silent
  }) => {
    let response = await ApiGetFinanceiroDashboardMotorInsights({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Origem,
      Page,
      PerPage,
      Silent
    });
    return response;
  }
);

// Opções dos selects de Produto/Cliente do Filtros — não existe um endpoint
// de busca/autocomplete dedicado, então reaproveita os mesmos endpoints
// paginados de /dashboard/produtos e /dashboard/clientes, sem o filtro
// Produto/Cliente, pedindo uma página maior (o suficiente pra cobrir o
// catálogo inteiro na maioria dos casos) só pra popular as opções de busca.
export const getFinanceiroDashboardProdutoOpcoes = createAsyncThunk(
  'api/getfinanceirodashboardprodutoopcoes',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Origem, Silent }) => {
    let response = await ApiGetFinanceiroDashboardProdutos({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Origem: Origem || 'Todos',
      Page: 1,
      PerPage: 300,
      Silent
    });
    return response;
  }
);

export const getFinanceiroDashboardClienteOpcoes = createAsyncThunk(
  'api/getfinanceirodashboardclienteopcoes',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Origem, Silent }) => {
    let response = await ApiGetFinanceiroDashboardClientes({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Origem: Origem || 'Todos',
      Page: 1,
      PerPage: 300,
      Silent
    });
    return response;
  }
);

export const getLevdataCenarioVendas = createAsyncThunk(
  'api/getlevdatacenarioVendas',
  async ({ Cnpj, Ano, Mes, DataInicio, DataFim, Silent }) => {
    let response = await ApiGetLevdataCenarioVendas({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      Silent
    });
    return response;
  }
);

export const getLevdataCreditosPotenciaisInsights = createAsyncThunk(
  'api/getlevdatacreditospotenciaisinsights',
  async ({
    Cnpj,
    Ano,
    Mes,
    DataInicio,
    DataFim,
    LR_FA,
    LR_FR,
    LR_EA,
    LR_ER,
    LP_FA,
    LP_FR,
    LP_EA,
    LP_ER,
    SN_FA,
    SN_FR,
    SN_EA,
    SN_ER,
    SNH_FA,
    SNH_FR,
    SNH_EA,
    SNH_ER
  }) => {
    let response = await ApiGetLevdataCreditosPotenciaisInsights({
      Cnpj,
      Ano,
      Mes,
      DataInicio,
      DataFim,
      LR_FA,
      LR_FR,
      LR_EA,
      LR_ER,
      LP_FA,
      LP_FR,
      LP_EA,
      LP_ER,
      SN_FA,
      SN_FR,
      SN_EA,
      SN_ER,
      SNH_FA,
      SNH_FR,
      SNH_EA,
      SNH_ER
    });
    return response;
  }
);

export const getLevdataRegimeTributarioSimulacao = createAsyncThunk(
  'api/getlevdataregimetributariosimulacao',
  async ({ Cnpj, AnoCalendario, Ano, Mes, Silent }) => {
    let response = await ApiGetLevdataRegimeTributarioSimulacao({
      Cnpj,
      AnoCalendario,
      Ano,
      Mes,
      Silent
    });
    return response;
  }
);

export const getLevdataRegimeTributarioComparativo = createAsyncThunk(
  'api/getlevdataregimetributariocomparativo',
  async ({
    Cnpj,
    AnoCalendario,
    Ano,
    Mes,
    Anexo,
    Atividade,
    SujeitoFatorR,
    ReceitaMensal,
    Despesas,
    BaseCreditavelMensal,
    SimplesInss,
    SimplesRat,
    SimplesTerceiros,
    PresumidoBcIrpj,
    PresumidoBcCsll,
    PresumidoIr,
    PresumidoCsll,
    PresumidoPis,
    PresumidoCofins,
    PresumidoIss,
    PresumidoInss,
    PresumidoRat,
    PresumidoTerceiros,
    RealIbs,
    RealCbs,
    RealIr,
    RealCsll,
    RealPercentualTributavel,
    RealInss,
    RealRat,
    RealTerceiros,
    HibridoIbs,
    HibridoCbs,
    ClientePerfil,
    ClienteRegime,
    ClientePercentualCredito,
    Silent
  }) => {
    let response = await ApiGetLevdataRegimeTributarioComparativo({
      Cnpj,
      AnoCalendario,
      Ano,
      Mes,
      Anexo,
      Atividade,
      SujeitoFatorR,
      ReceitaMensal,
      Despesas,
      BaseCreditavelMensal,
      SimplesInss,
      SimplesRat,
      SimplesTerceiros,
      PresumidoBcIrpj,
      PresumidoBcCsll,
      PresumidoIr,
      PresumidoCsll,
      PresumidoPis,
      PresumidoCofins,
      PresumidoIss,
      PresumidoInss,
      PresumidoRat,
      PresumidoTerceiros,
      RealIbs,
      RealCbs,
      RealIr,
      RealCsll,
      RealPercentualTributavel,
      RealInss,
      RealRat,
      RealTerceiros,
      HibridoIbs,
      HibridoCbs,
      ClientePerfil,
      ClienteRegime,
      ClientePercentualCredito,
      Silent
    });
    return response;
  }
);

export const getLevdataRegimeTributarioMotorExecutivo = createAsyncThunk(
  'api/getlevdataregimetributariomotorexecutivo',
  async ({ Cnpj, AnoCalendario, Ano, Mes, Anexo, Silent }) => {
    let response = await ApiGetLevdataRegimeTributarioMotorExecutivo({
      Cnpj,
      AnoCalendario,
      Ano,
      Mes,
      Anexo,
      Silent
    });
    return response;
  }
);

export const postLevdataPrecificacaoNotaValor = createAsyncThunk(
  'api/postlevdataprecificacaonotavalor',
  async ({ Cnpj, Tipo, CodProd, IdDados, ItensCompra, ItemVendaVinculado }) => {
    let response = await ApiPostLevdataPrecificacaoNotaValor({
      Cnpj,
      Tipo,
      CodProd,
      IdDados,
      ItensCompra,
      ItemVendaVinculado
    });
    return response;
  }
);

export const getLevdataPrecificacaoProdutoNfe = createAsyncThunk(
  'api/getlevdataprecificacaoprodutonfe',
  async ({ Cnpj, NCM, Cod, Descricao, Descricao_produto }) => {
    let response = await ApiGetLevdataPrecificacaoProdutoNfe({
      Cnpj,
      NCM,
      Cod,
      Descricao,
      Descricao_produto
    });
    return response;
  }
);

export const getLevdataPrecificacaoProdutoNfse = createAsyncThunk(
  'api/getlevdataprecificacaoprodutonfse',
  async ({ Cnpj, Descricao, Cod }) => {
    let response = await ApiGetLevdataPrecificacaoProdutoNfse({
      Cnpj,
      Descricao,
      Cod
    });
    return response;
  }
);

export const postLevdataPrecificacaoCombinarProduto = createAsyncThunk(
  'api/postlevdataprecificacaocombinarproduto',
  async ({
    Cnpj,
    CodProEmpresa,
    CodProFornPairs,
    id_dados_itens_v,
    id_dados_itens_c
  }) => {
    let response = await ApiPostLevdataPrecificacaoCombinarProduto({
      Cnpj,
      CodProEmpresa,
      CodProFornPairs,
      id_dados_itens_v,
      id_dados_itens_c
    });
    return response;
  }
);

export const postLevdataPrecificacaoCombinarServico = createAsyncThunk(
  'api/postlevdataprecificacaocombinarservico',
  async ({
    Cnpj,
    CodServEmpresa,
    CodServFornPairs,
    id_nota_servico_v,
    id_nota_servico_c
  }) => {
    let response = await ApiPostLevdataPrecificacaoCombinarServico({
      Cnpj,
      CodServEmpresa,
      CodServFornPairs,
      id_nota_servico_v,
      id_nota_servico_c
    });
    return response;
  }
);

export const getLevdataPrecificacaoFavoritos = createAsyncThunk(
  'api/getlevdataprecificacaofavoritos',
  async ({ Cnpj, Tipo }) => {
    let response = await ApiGetLevdataPrecificacaoFavoritos({ Cnpj, Tipo });
    return response;
  }
);

export const postLevdataPrecificacaoToggleFavorito = createAsyncThunk(
  'api/postlevdataprecificacaotogglefavorito',
  async ({ Cnpj, Tipo, Direcao, Codigo }) => {
    let response = await ApiPostLevdataPrecificacaoToggleFavorito({
      Cnpj,
      Tipo,
      Direcao,
      Codigo
    });
    return response;
  }
);

export const getLevdataPrecificacaoSimulacaoProduto = createAsyncThunk(
  'api/getlevdataprecificacaosimulacaoproduto',
  async ({ Cnpj }) => {
    let response = await ApiGetLevdataPrecificacaoSimulacaoProduto({
      Cnpj
    });
    return response;
  }
);

export const getLevdataPrecificacaoCalculoCenario = createAsyncThunk(
  'api/getlevdataprecificacaocalculocenario',
  async ({
    Tipo,
    CostoBruto,
    CustoAdicional,
    Tributo,
    Margem,
    Cnpj,
    CodigoProduto,
    NomeProduto,
    CostoBrutoOriginal,
    CustoAdicionalOriginal,
    TributoOriginal,
    MargemOriginal
  }) => {
    let response = await ApiGetLevdataPrecificacaoCalculoCenario({
      Tipo,
      CostoBruto,
      CustoAdicional,
      Tributo,
      Margem,
      Cnpj,
      CodigoProduto,
      NomeProduto,
      CostoBrutoOriginal,
      CustoAdicionalOriginal,
      TributoOriginal,
      MargemOriginal
    });
    return response;
  }
);

export const getLevdataPrecificacaoCalculoTributario = createAsyncThunk(
  'api/getlevdataprecificacaocalculotributario',
  async ({
    Tipo,
    CostoBruto,
    CustoAdicional,
    Tributo,
    Margem,
    Cnpj,
    credito,
    CodigoProduto,
    NomeProduto,
    CostoBrutoOriginal,
    CustoAdicionalOriginal,
    TributoOriginal,
    creditoOriginal,
    MargemOriginal
  }) => {
    let response = await ApiGetLevdataPrecificacaoCalculoTributario({
      Tipo,
      CostoBruto,
      CustoAdicional,
      Tributo,
      Margem,
      Cnpj,
      credito,
      CodigoProduto,
      NomeProduto,
      CostoBrutoOriginal,
      CustoAdicionalOriginal,
      TributoOriginal,
      creditoOriginal,
      MargemOriginal
    });
    return response;
  }
);

export const getLevdataPrecificacaoHistorico = createAsyncThunk(
  'api/getlevdataprecificacaohistorico',
  async ({
    Cnpj,
    Tipo,
    Page,
    PerPage,
    DataCriacao,
    DataInicio,
    DataFim,
    IdUsuario,
    CodigoProduto,
    NomeProduto,
    Silent
  }) => {
    let response = await ApiGetLevdataPrecificacaoHistorico({
      Cnpj,
      Tipo,
      Page,
      PerPage,
      DataCriacao,
      DataInicio,
      DataFim,
      IdUsuario,
      CodigoProduto,
      NomeProduto,
      Silent
    });
    return response;
  }
);

// TABELA BC / CNAE (Cadastros Básicos - Levdata)
export const getTabelaBc = createAsyncThunk(
  'api/gettabelabc',
  async ({ page, per_page } = {}) => {
    let response = await ApiGetTabelaBc({ page, per_page });
    return response;
  }
);

export const getListaCnae = createAsyncThunk(
  'api/getlistacnae',
  async ({ page, per_page, codigo } = {}) => {
    let response = await ApiGetListaCnae({ page, per_page, codigo });
    return response;
  }
);

export const putUpdateCnaeIdBc = createAsyncThunk(
  'api/putupdatecnaeidbc',
  async ({ Id, IdBc }) => {
    let response = await ApiUpdateCnaeIdBc({ Id, IdBc });
    return response;
  }
);

export const postTransferenciaConta = createAsyncThunk(
  'api/posttransferenciaconta',
  async ({
    IdMovOrigem,
    IdMovDestino,
    IdEmpresa,
    DataVencimento,
    IdCategoriaOrigem,
    IdCategoriaDestino,
    DetalhamentoOrigem,
    DetalhamentoDestino,
    Valor,
    TipoLancamento
  }) => {
    let response = await ApiPostTransferenciaConta({
      IdMovOrigem,
      IdMovDestino,
      IdEmpresa,
      DataVencimento,
      IdCategoriaOrigem,
      IdCategoriaDestino,
      DetalhamentoOrigem,
      DetalhamentoDestino,
      Valor,
      TipoLancamento
    });
    return response;
  }
);

export const postCreateTabelaBc = createAsyncThunk(
  'api/postcreatetabelabc',
  async ({ Atividade, Simples, AnexoSimples, BC }) => {
    let response = await ApiCreateTabelaBc({
      Atividade,
      Simples,
      AnexoSimples,
      BC
    });
    return response;
  }
);

export const putUpdateTabelaBc = createAsyncThunk(
  'api/putupdatetabelabc',
  async ({ Id, Atividade, Simples, AnexoSimples, BC }) => {
    let response = await ApiUpdateTabelaBc({
      Id,
      Atividade,
      Simples,
      AnexoSimples,
      BC
    });
    return response;
  }
);

export const deleteTabelaBc = createAsyncThunk(
  'api/deletetabelabc',
  async (Id) => {
    let response = await ApiDeleteTabelaBc(Id);
    return response;
  }
);

export const putUpdateCnae = createAsyncThunk(
  'api/putupdatecnae',
  async ({ Id, Descricao, AnexoPadrao, FatorR, AnexoComFatorR }) => {
    let response = await ApiUpdateCnae({
      Id,
      Descricao,
      AnexoPadrao,
      FatorR,
      AnexoComFatorR
    });
    return response;
  }
);

export const deleteListaCnae = createAsyncThunk(
  'api/deletelistacnae',
  async ({ Id, DesLink }) => {
    let response = await ApiDeleteCnae({
      Id,
      DesLink
    });
    return response;
  }
);
export const postCreateCnae = createAsyncThunk(
  'api/postcreatecnae',
  async ({ Codigo, AnexoPadrao, Descricao, FatorR, AnexoComFatorR, IdBc }) => {
    let response = await ApiCreateCnae({
      Codigo,
      AnexoPadrao,
      Descricao,
      FatorR,
      AnexoComFatorR,
      IdBc
    });
    return response;
  }
);

export const subidaDeDocumentosDataSlice = createSlice({
  name: 'subidadedocumentos',
  initialState: {
    // getUploaeddFiles
    files: [],
    isLoadingFiles: false,
    // getUploadedFilesNoType
    allFiles: [],
    isLoadingAllFiles: false,
    // getTypeOptions
    types: [],
    isLoadingTypes: false,
    //saveUploadedFiles:
    isSavingFiles: false,
    savedFiles: false,
    //deleteUploadedFiles:
    isDeletingFiles: false,
    deletedFile: false,
    //createExecution:
    isCreatingExec: false,
    createdExec: {},
    //getExecution:
    execution: [],
    isLoadingExecution: false,
    //getListDocumentType
    listDocumentType: [],
    isLoadingListDocumentType: false,
    //postDocumentType
    isLoadingDocumentType: false,
    documentType: {},
    //getListDocumentId
    listDocumentsByType: [],
    isLoadingListDocumentsByType: false,
    //getListDocumentIdForAttach
    listDocsByTypeForAttach: [],
    isLoadingListDocsByTypeForAttach: false,
    //record and reset dlm doc type id:
    dlmDocumentTypeData: {},
    //record and reset dlm doc version data:
    dlmDocumentVersionData: [],
    dlmDocsSelected: '',
    //dlm post tag:
    isLoadingPostDLMTag: false,
    postedDLMTag: {},
    //dlm put tags:
    isUpdatingDLMTag: false,
    updateDLMTag: {},
    //dlm get tags:
    isLoadingDLMTags: false,
    dlmTags: [],
    //dlm post workflow:
    isLoadingPostDLMWorkflow: false,
    postedDLMWorkflow: {},
    //get dlm workflow:
    isLoadingDLMWorkflow: false,
    dlmWorkflow: [],
    //post dlm tag document:
    isLoadingPostDLMTagDocument: false,
    postedDLMTagDocument: {},
    //get dlm list keyword:
    isLoadingDLMListKeyword: false,
    dlmListKeyword: [],
    //post dlm create keyword:
    isLoadingPostDLMCreateKeyword: false,
    postedDLMCreateKeyword: {},
    //post dlm create keyword doc:
    isLoadingPostDLMCreateKeywordDoc: false,
    postedDLMCreateKeywordDoc: {},
    //post dlm validate tag:
    isLoadingPostDLMValidateTag: false,
    postedDLMValidateTag: {},
    //delete dlm doc:
    isDeletingDLMDoc: false,
    //delete dlm keyword:
    isDeletingDLMKeyword: false,
    //post dlm create tag warning:
    isLoadingPostDLMCreateTagWarning: false,
    postedDLMCreateTagWarning: {},
    //put dlm edit tag warning:
    isUpdatingDLMTagWarning: false,
    updateDLMTagWarning: [],
    //put dlm update tag workflow:
    isUpdatingTagWorkflow: false,
    updateTagWorkflow: [],
    //get dlm list tag warning:
    isLoadingDLMListTagWarning: false,
    dlmListTagWarning: [],
    //delete dlm tag:
    isDeletingDLMTag: false,
    //delete dlm tag workflows:
    isDeletingDLMTagWorkflows: false,
    // postDLMDocumentVersion:
    isLoadingPostDLMDocumentVersion: false,
    postedDLMDocumentVersion: {},
    //putDLMDocumentApproval:
    isPutDLMDocumentApproval: false,
    updateDLMDocumentApproval: {},
    //postDLMDocument:
    isPostDLMDocument: false,
    postedDLMDocument: {},
    //postdlmattachdocuments:
    isLoadingPostDLMAttachDocuments: false,
    postedDLMAttachDocuments: {},
    //deletedlmattachdocuments:
    isDeletingDLMAttachDocuments: false,
    //postdlmattachfiles:
    isLoadingPostDLMAttachFiles: false,
    postedDLMAttachFiles: {},
    //postdlmvalidatetagemail:
    isLoadingPostDLMValidateTagEmail: false,
    postedDLMValidateTagEmail: {},
    //uploadflightdata
    uploadFlightDataResponse: [],
    uploadPriceReportDataResponse: [],
    //getreconciliationdata
    listReconciliationData: [],
    isLoadingListReconciliationData: false,
    //postreconannotations:
    isLoadingPostReconAnnotations: false,
    postedPostReconAnnotations: {},
    //getreconannotations
    isLoadingListReconAnnotations: false,
    listReconAnnotations: [],
    //putreconannotations:
    isPutReconAnnotations: false,
    updateReconAnnotations: {},
    //deletedreconannotations:
    isDeletingReconAnnotations: false,
    //getchatgpt
    isLoadingPostChatGptDLMQuestion: false,
    postedChatGptDLMQuestion: {},
    isLoadingPostChatGptDLMResponse: false,
    postedChatGptDLMResponse: {},
    //postdlmdepartment
    isLoadingPostDLMDepartment: false,
    postedDLMDepartment: {},
    //getdlmdepartment
    listDLMDepartment: {},
    isLoadingListDLMDepartment: false,
    //getdlmdocumentfeild
    isLoadingListDLMDocumentField: false,
    listDLMDocumentField: {},
    //putdlmdepartment
    isLoadingPutDLMDepartment: false,
    putDLMDepartment: {},
    //postdlmdocumentfeild
    isLoadingPostDLMDocumentField: false,
    postedDLMDocumentField: {},
    //putdlmdocumentfeild
    isLoadingPutDLMDocumentField: false,
    putDLMDocumentField: {},
    //postdlmdoctypefeilds
    isLoadingPostDLMDocTypeFields: false,
    postedDLMDocTypeFields: {},
    //getdlmdoctypefeilds
    isLoadingListDLMDocTypeFields: false,
    listDLMDocTypeFields: {},
    //putdlmdoctypefeilds
    isLoadingPutDLMDocTypeFields: false,
    putDLMDocTypeFields: {},
    //deletedlmdoctypefeilds
    isDeletingDLMDocTypeFields: false,
    //postdlmdoctypevalidvalues
    isLoadingPostDLMDocTypeValidValues: false,
    postedDLMDocTypeValidValues: {},
    //getdlmdoctypevalidvalues
    isLoadingListDLMDocTypeValidValues: false,
    listDLMDocTypeFieldsValidValues: {},
    //putdlmdoctypevalidvalues
    isLoadingPutDLMDocTypeValidValues: false,
    putDLMDocTypeValidValues: {},
    //deletedlmdoctypevalidvalues
    isDeletingDLMDocTypeValidValues: false,
    //postdlmconfidentiality
    isLoadingPostDLMConfidentiality: false,
    postedDLMConfidentiality: {},
    //getdlmconfidentiality
    isLoadingListDLMConfidentiality: false,
    listDLMConfidentiality: {},
    //deletedlmconfidentiality
    isDeletingDLMConfidentiality: false,
    //postdlmusersaccesses
    isLoadingPostDLMUsersAccesses: false,
    postedDLMUsersAccesses: {},
    //getdlmusersaccesses
    isLoadingListDLMUsersAccesses: false,
    listDLMUsersAccesses: {},
    //deletedlmusersaccesses
    isDeletingDLMUsersAccesses: false,
    //putdlmusersaccesses
    isLoadingPutDLMUsersAccesses: false,
    putDLMUsersAccesses: {},
    //postcreateaccount
    isLoadingPostCreateAccount: false,
    postedCreateAccount: {},
    //getlistaccount
    isLoadingListAccount: false,
    listAccount: {},
    //putupdateaccount
    isLoadingPutUpdateAccount: false,
    putUpdateAccount: {},
    //deleteaccount
    isDeletingAccount: false,
    //postcreatebank
    isLoadingPostCreateBank: false,
    postedCreateBank: {},
    //getlistbank
    isLoadingListBank: false,
    listBank: {},
    //putupdatebank
    isLoadingPutUpdateBank: false,
    putUpdateBank: {},
    //deletebank
    isDeletingBank: false,
    //getlistextract
    isLoadingListExtract: false,
    listExtract: {},
    //deleteextract
    isDeletingExtract: false,
    //getlistcategory
    isLoadingListCategory: false,
    listCategory: {},
    //postcreatecategory
    isLoadingPostCreateCategory: false,
    postedCreateCategory: {},
    //putupdatecategory
    isLoadingPutUpdateCategory: false,
    putUpdateCategory: {},
    //deletecategory
    isDeletingCategory: false,
    //getlistlancamento
    isLoadingListLancamento: false,
    listLancamento: {},
    //postcreatelancamento
    isLoadingPostCreateLancamento: false,
    postedCreateLancamento: {},
    //putupdatelancamento
    isLoadingPutUpdateLancamento: false,
    putUpdateLancamento: {},
    //deletelancamento
    isDeletingLancamento: false,
    //getlistconciliacao
    isLoadingListConciliacao: false,
    listConciliacao: {},
    //getlistsimulacao
    isLoadingListSimulacao: false,
    listSimulacao: {},
    //putupdatevincmovimentacao
    isLoadingPutUpdateVincMovimentacao: false,
    putUpdateVincMovimentacao: {},
    ////putupdatedesvincmovimentacao
    isLoadingPutUpdateDesvincMovimentacao: false,
    putUpdateDesvincMovimentacao: {},
    //getlistsimulacaoconta
    isLoadingListSimulacaoConta: false,
    listSimulacaoConta: {},
    //postcreatelancamentoconciliacao
    isLoadingPostCreateLancamentoConciliacao: false,
    postedCreateLancamentoConciliacao: {},
    //getexecuteconciliacao
    isLoadingExecuteConciliacao: false,
    listExecuteConciliacao: {},
    //getgestofinanceiracontato
    isLoadingGestaoFinanceiraContato: false,
    listGestaoFinanceiraContato: {},
    //getextractmovements
    isLoadingExtractMovements: false,
    listExtractMovements: {},
    //getvalidateextract
    isLoadingValidateExtract: false,
    listValidateExtract: {},
    //gettransferenciaconta
    isLoadingTransferenciaConta: false,
    listTransferenciaConta: {},
    //posttransferenciaconta
    isLoadingPostTransferenciaConta: false,
    postedTransferenciaConta: {},
    //getlevdataempresainfo
    isLoadingLevidataEmpresaInfo: false,
    listLevdataEmpresaInfo: {},
    //getlevdataimpostos
    isLoadingLevidataImpostos: false,
    listLevdataImpostos: {},
    //getlevdatamargem
    isLoadingLevidataMargem: false,
    listLevdataMargem: {},
    //getlevdatasituacaotributaria
    isLoadingLevidataSituacaoTributaria: false,
    listLevdataSituacaoTributaria: {},
    //getlevdatalevnotas
    isLoadingLevidataLevNotas: false,
    listLevdataLevNotas: {},
    //getlevdatareceita
    isLoadingLevidataReceita: false,
    listLevdataReceita: {},
    //getlevdatahistoricodashboard
    isLoadingLevidataHistoricoDashboard: false,
    listLevdataHistoricoDashboard: {},
    //getlevdatacomprasentrada
    isLoadingLevidataComprasEntrada: false,
    listLevdataComprasEntrada: {},
    //getlevdatalimiteutilizado
    isLoadingLevidataLimiteUtilizado: false,
    listLevdataLimiteUtilizado: {},
    //getlevdataregimeatual
    isLoadingLevidataRegimeAtual: false,
    listLevdataRegimeAtual: {},
    //getlevdataaliquotaatual
    isLoadingLevidataAliquotaAtual: false,
    listLevdataAliquotaAtual: {},
    //getlevdatadespesas
    isLoadingLevidataDespesas: false,
    listLevdataDespesas: {},
    //getlevdatareceitadiagnostico
    isLoadingLevidataReceitaDiagnostico: false,
    listLevdataReceitaDiagnostico: {},
    //getlevdatadespesasdiagnostico
    isLoadingLevidataDespesasDiagnostico: false,
    listLevdataDespesasDiagnostico: {},
    isLoadingLevidataCreditoPotencialDiagnostico: false,
    listLevdataCreditoPotencialDiagnostico: {},
    //getlevdatacreditopotencial
    isLoadingLevidataCreditoPotencial: false,
    listLevdataCreditoPotencial: {},
    //getlevdatacomprassemcredito
    isLoadingLevidataComprasSemCredito: false,
    listLevdataComprasSemCredito: {},
    //getlevdatadetalhamentolucro
    isLoadingLevidataDetalhamentoLucro: false,
    listLevdataDetalhamentoLucro: {},
    //getlevdatacreditosfiscais
    isLoadingLevidataCreditosFiscais: false,
    listLevdataCreditosFiscais: {},
    //getlevdatafornecedorporcredito
    isLoadingLevidataFornecedorPorCredito: false,
    listLevdataFornecedorPorCredito: {},
    //getlevdatasemcreditopotencial
    isLoadingLevidataSemCreditoPotencial: false,
    listLevdataSemCreditoPotencial: {},
    //getlevdatacreditopiscofins
    isLoadingLevidataCreditoPisCofins: false,
    listLevdataCreditoPisCofins: {},
    //getlevdatahistoricocreditos
    isLoadingLevidataHistoricoCreditos: false,
    listLevdataHistoricoCreditos: {},
    //getlevdatadashboardinsights
    isLoadingLevidataDashboardInsights: false,
    listLevdataDashboardInsights: [],
    //getfinanceirodashboardprodutos
    isLoadingFinanceiroDashboardProdutos: false,
    listFinanceiroDashboardProdutos: {},
    //getfinanceirodashboardclientes
    isLoadingFinanceiroDashboardClientes: false,
    listFinanceiroDashboardClientes: {},
    //getfinanceirodashboardmotorinsights
    isLoadingFinanceiroDashboardMotorInsights: false,
    listFinanceiroDashboardMotorInsights: {},
    //getfinanceirodashboardprodutoopcoes
    isLoadingFinanceiroDashboardProdutoOpcoes: false,
    listFinanceiroDashboardProdutoOpcoes: {},
    //getfinanceirodashboardclienteopcoes
    isLoadingFinanceiroDashboardClienteOpcoes: false,
    listFinanceiroDashboardClienteOpcoes: {},
    //getlevdatacenarioVendas
    isLoadingLevidataCenarioVendas: false,
    listLevdataCenarioVendas: {},
    //getlevdatacreditopotenciaisinsights
    isLoadingLevidataCreditosPotenciaisInsights: false,
    listLevdataCreditosPotenciaisInsights: {},
    //getlevdataregimetributariosimulacao
    isLoadingLevidataRegimeTributarioSimulacao: false,
    listLevdataRegimeTributarioSimulacao: {},
    //getlevdataregimetributariocomparativo
    isLoadingLevidataRegimeTributarioComparativo: false,
    listLevdataRegimeTributarioComparativo: {},
    //getlevdataregimetributariomotorexecutivo
    isLoadingLevidataRegimeTributarioMotorExecutivo: false,
    listLevdataRegimeTributarioMotorExecutivo: {},
    //getlevdataprecificacaonotavalor
    isLoadingPostLevidataPrecificacaoNotaValor: false,
    postedLevdataPrecificacaoNotaValor: {},
    //getlevdataprecificacaoprodutonfe
    isLoadingLevidataPrecificacaoProdutoNfe: false,
    listLevdataPrecificacaoProdutoNfe: {},
    //getlevdataprecificacaoprodutonfse
    isLoadingLevidataPrecificacaoProdutoNfse: false,
    listLevdataPrecificacaoProdutoNfse: {},
    //postlevdataprecificacaocombinarproduto
    isLoadingPostLevidataPrecificacaoCombinarProduto: false,
    postedLevdataPrecificacaoCombinarProduto: {},
    //postlevdataprecificacaocombinarservico
    isLoadingPostLevidataPrecificacaoCombinarServico: false,
    postedLevdataPrecificacaoCombinarServico: {},
    //getlevdataprecificacaofavoritos
    isLoadingLevidataPrecificacaoFavoritos: false,
    listLevdataPrecificacaoFavoritos: {},
    //postlevdataprecificacaotogglefavorito
    isLoadingPostLevidataPrecificacaoToggleFavorito: false,
    //getlevdataprecificacaosimulacaoproduto
    isLoadingLevidataPrecificacaoSimulacaoProduto: false,
    listLevdataPrecificacaoSimulacaoProduto: {},
    //getlevdataprecificacaocalculocenario
    isLoadingLevidataPrecificacaoCalculoCenario: false,
    listLevdataPrecificacaoCalculoCenario: {},
    //getlevdataprecificacaocalculotributario
    isLoadingLevidataPrecificacaoCalculoTributario: false,
    listLevdataPrecificacaoCalculoTributario: {},
    //getlevdataprecificacaohistorico
    isLoadingLevidataPrecificacaoHistorico: false,
    listLevdataPrecificacaoHistorico: {},
    //gettabelabc
    isLoadingTabelaBc: false,
    listTabelaBc: {},
    //getlistacnae
    isLoadingListaCnae: false,
    listListaCnae: {},
    //putupdatecnaeidbc
    isLoadingUpdateCnaeIdBc: false,
    updatedCnaeIdBc: {},
    //postcreatetabelabc
    isLoadingPostCreateTabelaBc: false,
    postedCreateTabelaBc: {},
    //putupdatetabelabc
    isLoadingPutUpdateTabelaBc: false,
    updatedTabelaBc: {},
    //deletetabelabc
    isDeletingTabelaBc: false,
    deletedTabelaBc: {},
    //putupdatecnae
    isLoadingPutUpdateCnae: false,
    updatedCnae: {},
    //deletelistacnae
    isDeletingListaCnae: false,
    deletedListaCnae: {},
    //postcreatecnae
    isLoadingPostCreateCnae: false,
    postedCreateCnae: {}
  },
  reducers: {},
  extraReducers: {
    [recordDLMDocTypeData]: (state, action) => {
      state.dlmDocumentTypeData = action.payload;
    },
    [recordDLMDocVersionData]: (state, action) => {
      state.dlmDocumentVersionData = action.payload;
    },
    [recordDLMDocsSelected]: (state, action) => {
      state.dlmDocsSelected = action.payload;
    },
    [getUploadedFiles.pending]: (state) => {
      state.isLoadingFiles = 'loading';
    },
    [getUploadedFiles.fulfilled]: (state, action) => {
      state.isLoadingFiles = 'success';
      state.files = action.payload;
    },
    [getUploadedFiles.rejected]: (state) => {
      state.isLoadingFiles = 'failed';
    },
    [getUploadedFilesNoType.pending]: (state) => {
      state.isLoadingAllFiles = 'loading';
    },
    [getUploadedFilesNoType.fulfilled]: (state, action) => {
      state.isLoadingAllFiles = 'success';
      state.allFiles = action.payload;
    },
    [getUploadedFilesNoType.rejected]: (state) => {
      state.isLoadingAllFiles = 'failed';
    },
    [getTypeOptions.pending]: (state) => {
      state.isLoadingTypes = 'loading';
    },
    [getTypeOptions.fulfilled]: (state, action) => {
      state.isLoadingTypes = 'success';
      state.types = action.payload;
    },
    [getTypeOptions.rejected]: (state) => {
      state.isLoadingTypes = 'failed';
    },
    [saveUploadedFiles.pending]: (state) => {
      state.isSavingFiles = 'loading';
    },
    [saveUploadedFiles.fulfilled]: (state, action) => {
      state.isSavingFiles = 'success';
      state.savedFiles = action.payload;
    },
    [saveUploadedFiles.rejected]: (state) => {
      state.isSavingFiles = 'failed';
    },
    [deleteUploadedFiles.pending]: (state) => {
      state.isDeletingFiles = 'loading';
    },
    [deleteUploadedFiles.fulfilled]: (state, action) => {
      state.isDeletingFiles = 'success';
      state.deletedFile = action.payload;
    },
    [deleteUploadedFiles.rejected]: (state) => {
      state.isDeletingFiles = 'failed';
    },
    [createExecution.pending]: (state) => {
      state.isCreatingExec = 'loading';
    },
    [createExecution.fulfilled]: (state, action) => {
      state.isCreatingExec = 'success';
      state.createdExec = action.payload;
    },
    [createExecution.rejected]: (state) => {
      state.isCreatingExec = 'failed';
    },
    [getExecution.pending]: (state) => {
      state.isLoadingExecution = 'loading';
    },
    [getExecution.fulfilled]: (state, action) => {
      state.isLoadingExecution = 'success';
      state.execution = action.payload;
    },
    [getExecution.rejected]: (state) => {
      state.isLoadingExecution = 'failed';
    },
    [getDocumentTypes.pending]: (state) => {
      state.isLoadingListDocumentType = 'loading';
    },
    [getDocumentTypes.fulfilled]: (state, action) => {
      state.isLoadingListDocumentType = 'success';
      state.listDocumentType = action.payload;
    },
    [getDocumentTypes.rejected]: (state) => {
      state.isLoadingListDocumentType = 'failed';
    },
    [postDocumentType.pending]: (state) => {
      state.isLoadingDocumentType = 'loading';
    },
    [postDocumentType.fulfilled]: (state, action) => {
      state.isLoadingDocumentType = 'success';
      state.documentType = action.payload;
    },
    [postDocumentType.rejected]: (state) => {
      state.isLoadingDocumentType = 'failed';
    },
    [getDocumentsByType.pending]: (state) => {
      state.isLoadingListDocumentsByType = 'loading';
    },
    [getDocumentsByType.fulfilled]: (state, action) => {
      state.isLoadingListDocumentsByType = 'success';
      state.listDocumentsByType = action.payload;
    },
    [getDocumentsByType.rejected]: (state) => {
      state.isLoadingListDocumentsByType = 'failed';
    },
    [getDocsByTypeForAttach.pending]: (state) => {
      state.isLoadingListDocsByTypeForAttach = 'loading';
    },
    [getDocsByTypeForAttach.fulfilled]: (state, action) => {
      state.isLoadingListDocsByTypeForAttach = 'success';
      state.listDocsByTypeForAttach = action.payload;
    },
    [getDocsByTypeForAttach.rejected]: (state) => {
      state.isLoadingListDocsByTypeForAttach = 'failed';
    },
    [postDLMTag.pending]: (state) => {
      state.isLoadingPostDLMTag = 'loading';
    },
    [postDLMTag.fulfilled]: (state, action) => {
      state.isLoadingPostDLMTag = 'success';
      state.postedDLMTag = action.payload;
    },
    [postDLMTag.rejected]: (state) => {
      state.isLoadingPostDLMTag = 'failed';
    },
    [putDLMTag.pending]: (state) => {
      state.isUpdatingDLMTag = 'loading';
    },
    [putDLMTag.fulfilled]: (state, action) => {
      state.isUpdatingDLMTag = 'success';
      state.updateDLMTag = action.payload;
    },
    [putDLMTag.rejected]: (state) => {
      state.isUpdatingDLMTag = 'failed';
    },
    [getDLMTags.pending]: (state) => {
      state.isLoadingDLMTags = 'loading';
    },
    [getDLMTags.fulfilled]: (state, action) => {
      state.isLoadingDLMTags = 'success';
      state.dlmTags = action.payload;
    },
    [getDLMTags.rejected]: (state) => {
      state.isLoadingDLMTags = 'failed';
    },
    [postDLMWorkflow.pending]: (state) => {
      state.isLoadingPostDLMWorkflow = 'loading';
    },
    [postDLMWorkflow.fulfilled]: (state, action) => {
      state.isLoadingPostDLMWorkflow = 'success';
      state.postedDLMWorkflow = action.payload;
    },
    [postDLMWorkflow.rejected]: (state) => {
      state.isLoadingPostDLMWorkflow = 'failed';
    },
    [getDLMWorkflow.pending]: (state) => {
      state.isLoadingDLMWorkflow = 'loading';
    },
    [getDLMWorkflow.fulfilled]: (state, action) => {
      state.isLoadingDLMWorkflow = 'success';
      state.dlmWorkflow = action.payload;
    },
    [getDLMWorkflow.rejected]: (state) => {
      state.isLoadingDLMWorkflow = 'failed';
    },
    [postDLMTagDocument.pending]: (state) => {
      state.isLoadingPostDLMTagDocument = 'loading';
    },
    [postDLMTagDocument.fulfilled]: (state, action) => {
      state.isLoadingPostDLMTagDocument = 'success';
      state.postedDLMTagDocument = action.payload;
    },
    [postDLMTagDocument.rejected]: (state) => {
      state.isLoadingPostDLMTagDocument = 'failed';
    },
    [getDLMKeywords.pending]: (state) => {
      state.isLoadingDLMListKeyword = 'loading';
    },
    [getDLMKeywords.fulfilled]: (state, action) => {
      state.isLoadingDLMListKeyword = 'success';
      state.dlmListKeyword = action.payload;
    },
    [getDLMKeywords.rejected]: (state) => {
      state.isLoadingDLMListKeyword = 'failed';
    },
    [postDLMKeyword.pending]: (state) => {
      state.isLoadingPostDLMCreateKeyword = 'loading';
    },
    [postDLMKeyword.fulfilled]: (state, action) => {
      state.isLoadingPostDLMCreateKeyword = 'success';
      state.postedDLMCreateKeyword = action.payload;
    },
    [postDLMKeyword.rejected]: (state) => {
      state.isLoadingPostDLMCreateKeyword = 'failed';
    },
    [postDLMKeywordDocument.pending]: (state) => {
      state.isLoadingPostDLMCreateKeywordDoc = 'loading';
    },
    [postDLMKeywordDocument.fulfilled]: (state, action) => {
      state.isLoadingPostDLMCreateKeywordDoc = 'success';
      state.postedDLMCreateKeywordDoc = action.payload;
    },
    [postDLMKeywordDocument.rejected]: (state) => {
      state.isLoadingPostDLMCreateKeywordDoc = 'failed';
    },
    [postDLMValidateTag.pending]: (state) => {
      state.isLoadingPostDLMValidateTag = 'loading';
    },
    [postDLMValidateTag.fulfilled]: (state, action) => {
      state.isLoadingPostDLMValidateTag = 'success';
      state.postedDLMValidateTag = action.payload;
    },
    [postDLMValidateTag.rejected]: (state) => {
      state.isLoadingPostDLMValidateTag = 'failed';
    },
    [deleteDLMDoc.pending]: (state) => {
      state.isDeletingDLMDoc = 'loading';
    },
    [deleteDLMDoc.fulfilled]: (state) => {
      state.isDeletingDLMDoc = 'success';
    },
    [deleteDLMDoc.rejected]: (state) => {
      state.isDeletingDLMDoc = 'failed';
    },
    [deleteDLMKeyword.pending]: (state) => {
      state.isDeletingDLMKeyword = 'loading';
    },
    [deleteDLMKeyword.fulfilled]: (state) => {
      state.isDeletingDLMKeyword = 'success';
    },
    [deleteDLMKeyword.rejected]: (state) => {
      state.isDeletingDLMKeyword = 'failed';
    },
    [postDLMTagWarning.pending]: (state) => {
      state.isLoadingPostDLMCreateTagWarning = 'loading';
    },
    [postDLMTagWarning.fulfilled]: (state, action) => {
      state.isLoadingPostDLMCreateTagWarning = 'success';
      state.postedDLMCreateTagWarning = action.payload;
    },
    [postDLMTagWarning.rejected]: (state) => {
      state.isLoadingPostDLMCreateTagWarning = 'failed';
    },
    [putDLMTagWarning.pending]: (state) => {
      state.isUpdatingDLMTagWarning = 'loading';
    },
    [putDLMTagWarning.fulfilled]: (state, action) => {
      state.isUpdatingDLMTagWarning = 'success';
      state.updateDLMTagWarning = action.payload;
    },
    [putDLMTagWarning.rejected]: (state) => {
      state.isUpdatingDLMTagWarning = 'failed';
    },
    [putDLMUpdateTagWorkflow.pending]: (state) => {
      state.isUpdatingTagWorkflow = 'loading';
    },
    [putDLMUpdateTagWorkflow.fulfilled]: (state, action) => {
      state.isUpdatingTagWorkflow = 'success';
      state.updateTagWorkflow = action.payload;
    },
    [putDLMUpdateTagWorkflow.rejected]: (state) => {
      state.isUpdatingTagWorkflow = 'failed';
    },

    [getDLMTagWarning.pending]: (state) => {
      state.isLoadingDLMListTagWarning = 'loading';
    },
    [getDLMTagWarning.fulfilled]: (state, action) => {
      state.isLoadingDLMListTagWarning = 'success';
      state.dlmListTagWarning = action.payload;
    },
    [getDLMTagWarning.rejected]: (state) => {
      state.isLoadingDLMListTagWarning = 'failed';
    },
    [deleteDLMTag.pending]: (state) => {
      state.isDeletingDLMTag = 'loading';
    },
    [deleteDLMTag.fulfilled]: (state) => {
      state.isDeletingDLMTag = 'success';
    },
    [deleteDLMTag.rejected]: (state) => {
      state.isDeletingDLMTag = 'failed';
    },
    [deleteDLMTagWorkflow.pending]: (state) => {
      state.isDeletingDLMTagWorkflows = 'loading';
    },
    [deleteDLMTagWorkflow.fulfilled]: (state) => {
      state.isDeletingDLMTagWorkflows = 'success';
    },
    [deleteDLMTagWorkflow.rejected]: (state) => {
      state.isDeletingDLMTagWorkflows = 'failed';
    },
    [postDLMDocumentVersion.pending]: (state) => {
      state.isLoadingPostDLMDocumentVersion = 'loading';
    },
    [postDLMDocumentVersion.fulfilled]: (state, action) => {
      state.isLoadingPostDLMDocumentVersion = 'success';
      state.postedDLMDocumentVersion = action.payload;
    },
    [postDLMDocumentVersion.rejected]: (state) => {
      state.isLoadingPostDLMDocumentVersion = 'failed';
    },
    [putDLMDocumentApproval.pending]: (state) => {
      state.isPutDLMDocumentApproval = 'loading';
    },
    [putDLMDocumentApproval.fulfilled]: (state, action) => {
      state.isPutDLMDocumentApproval = 'success';
      state.updateDLMDocumentApproval = action.payload;
    },
    [putDLMDocumentApproval.rejected]: (state) => {
      state.isPutDLMDocumentApproval = 'failed';
    },
    [postDLMDocument.pending]: (state) => {
      state.isPostDLMDocument = 'loading';
    },
    [postDLMDocument.fulfilled]: (state, action) => {
      state.isPostDLMDocument = 'success';
      state.postedDLMDocument = action.payload;
    },
    [postDLMDocument.rejected]: (state) => {
      state.isPostDLMDocument = 'failed';
    },
    [postDLMAttachDocuments.pending]: (state) => {
      state.isLoadingPostDLMAttachDocuments = 'loading';
    },
    [postDLMAttachDocuments.fulfilled]: (state, action) => {
      state.isLoadingPostDLMAttachDocuments = 'success';
      state.postedDLMAttachDocuments = action.payload;
    },
    [postDLMAttachDocuments.rejected]: (state) => {
      state.isLoadingPostDLMAttachDocuments = 'failed';
    },
    [deleteDLMAttachDocuments.pending]: (state) => {
      state.isDeletingDLMAttachDocuments = 'loading';
    },
    [deleteDLMAttachDocuments.fulfilled]: (state) => {
      state.isDeletingDLMAttachDocuments = 'success';
    },
    [deleteDLMAttachDocuments.rejected]: (state) => {
      state.isDeletingDLMAttachDocuments = 'failed';
    },
    [postDLMAttachFiles.pending]: (state) => {
      state.isLoadingPostDLMAttachFiles = 'loading';
    },
    [postDLMAttachFiles.fulfilled]: (state, action) => {
      state.isLoadingPostDLMAttachFiles = 'success';
      state.postedDLMAttachFiles = action.payload;
    },
    [postDLMAttachFiles.rejected]: (state) => {
      state.isLoadingPostDLMAttachFiles = 'failed';
    },
    [postDLMValidateTagEmail.pending]: (state) => {
      state.isLoadingPostDLMValidateTagEmail = 'loading';
    },
    [postDLMValidateTagEmail.fulfilled]: (state, action) => {
      state.isLoadingPostDLMValidateTagEmail = 'success';
      state.postedDLMValidateTagEmail = action.payload;
    },
    [postDLMValidateTagEmail.rejected]: (state) => {
      state.isLoadingPostDLMValidateTagEmail = 'failed';
    },
    [postFightData.pending]: () => {
      null;
    },
    [postFightData.fulfilled]: (state, action) => {
      state.uploadFlightDataResponse = action.payload;
    },
    [postFightData.rejected]: () => {
      null;
    },
    [postPriceReportData.pending]: () => {
      null;
    },
    [postPriceReportData.fulfilled]: (state, action) => {
      state.uploadPriceReportDataResponse = action.payload;
    },
    [postPriceReportData.rejected]: () => {
      null;
    },
    [getReconciliationData.pending]: (state) => {
      state.isLoadingListReconciliationData = 'loading';
    },
    [getReconciliationData.fulfilled]: (state, action) => {
      state.isLoadingListReconciliationData = 'success';
      state.listReconciliationData = action.payload;
    },
    [getReconciliationData.rejected]: (state) => {
      state.isLoadingListReconciliationData = 'failed';
    },
    [postReconAnnotations.pending]: (state) => {
      state.isLoadingPostReconAnnotations = 'loading';
    },
    [postReconAnnotations.fulfilled]: (state, action) => {
      state.isLoadingPostReconAnnotations = 'success';
      state.postedPostReconAnnotations = action.payload;
    },
    [postReconAnnotations.rejected]: (state) => {
      state.isLoadingPostReconAnnotations = 'failed';
    },
    [getReconAnnotations.pending]: (state) => {
      state.isLoadingListReconAnnotations = 'loading';
    },
    [getReconAnnotations.fulfilled]: (state, action) => {
      state.isLoadingListReconAnnotations = 'success';
      state.listReconAnnotations = action.payload;
    },
    [getReconAnnotations.rejected]: (state) => {
      state.isLoadingListReconAnnotations = 'failed';
    },
    [putReconAnnotations.pending]: (state) => {
      state.isPutReconAnnotations = 'loading';
    },
    [putReconAnnotations.fulfilled]: (state, action) => {
      state.isPutReconAnnotations = 'success';
      state.updateReconAnnotations = action.payload;
    },
    [putReconAnnotations.rejected]: (state) => {
      state.isPutReconAnnotations = 'failed';
    },
    [deleteReconAnnotations.pending]: (state) => {
      state.isDeletingReconAnnotations = 'loading';
    },
    [deleteReconAnnotations.fulfilled]: (state) => {
      state.isDeletingReconAnnotations = 'success';
    },
    [deleteReconAnnotations.rejected]: (state) => {
      state.isDeletingReconAnnotations = 'failed';
    },
    [postChatGptDLMQuestion.pending]: (state) => {
      state.isLoadingPostChatGptDLMQuestion = 'loading';
    },
    [postChatGptDLMQuestion.fulfilled]: (state, action) => {
      state.isLoadingPostChatGptDLMQuestion = 'success';
      state.postedChatGptDLMQuestion = action.payload;
    },
    [postChatGptDLMQuestion.rejected]: (state) => {
      state.isLoadingPostChatGptDLMQuestion = 'failed';
    },
    [postChatGptDLMResponse.pending]: (state) => {
      state.isLoadingPostChatGptDLMResponse = 'loading';
    },
    [postChatGptDLMResponse.fulfilled]: (state, action) => {
      state.isLoadingPostChatGptDLMResponse = 'success';
      state.postedChatGptDLMResponse = action.payload;
    },
    [postChatGptDLMResponse.rejected]: (state) => {
      state.isLoadingPostChatGptDLMResponse = 'failed';
    },
    [postDLMDepartment.pending]: (state) => {
      state.isLoadingPostDLMDepartment = 'loading';
    },
    [postDLMDepartment.fulfilled]: (state, action) => {
      state.isLoadingPostDLMDepartment = 'success';
      state.postedDLMDepartment = action.payload;
    },
    [postDLMDepartment.rejected]: (state) => {
      state.isLoadingPostDLMDepartment = 'failed';
    },
    [putDLMDepartment.pending]: (state) => {
      state.isLoadingPutDLMDepartment = 'loading';
    },
    [putDLMDepartment.fulfilled]: (state, action) => {
      state.isLoadingPutDLMDepartment = 'success';
      state.putDLMDepartment = action.payload;
    },
    [putDLMDepartment.rejected]: (state) => {
      state.isLoadingPutDLMDepartment = 'failed';
    },
    [getDLMDepartment.pending]: (state) => {
      state.isLoadingListDLMDepartment = 'loading';
    },
    [getDLMDepartment.fulfilled]: (state, action) => {
      state.isLoadingListDLMDepartment = 'success';
      state.listDLMDepartment = action.payload;
    },
    [getDLMDepartment.rejected]: (state) => {
      state.isLoadingListDLMDepartment = 'failed';
    },
    [getDLMDocumentField.pending]: (state) => {
      state.isLoadingListDLMDocumentField = 'loading';
    },
    [getDLMDocumentField.fulfilled]: (state, action) => {
      state.isLoadingListDLMDocumentField = 'success';
      state.listDLMDocumentField = action.payload;
    },
    [getDLMDocumentField.rejected]: (state) => {
      state.isLoadingListDLMDocumentField = 'failed';
    },
    [postDLMNewDocumentFeild.pending]: (state) => {
      state.isLoadingPostDLMDocumentField = 'loading';
    },
    [postDLMNewDocumentFeild.fulfilled]: (state, action) => {
      state.isLoadingPostDLMDocumentField = 'success';
      state.postedDLMDocumentField = action.payload;
    },
    [postDLMNewDocumentFeild.rejected]: (state) => {
      state.isLoadingPostDLMDocumentField = 'failed';
    },
    [putDLMDocumentFeild.pending]: (state) => {
      state.isLoadingPutDLMDocumentField = 'loading';
    },
    [putDLMDocumentFeild.fulfilled]: (state, action) => {
      state.isLoadingPutDLMDocumentField = 'success';
      state.putDLMDocumentField = action.payload;
    },
    [putDLMDocumentFeild.rejected]: (state) => {
      state.isLoadingPutDLMDocumentField = 'failed';
    },
    [postDLMDLMDocTypeFields.pending]: (state) => {
      state.isLoadingPostDLMDocTypeFields = 'loading';
    },
    [postDLMDLMDocTypeFields.fulfilled]: (state, action) => {
      state.isLoadingPostDLMDocTypeFields = 'success';
      state.postedDLMDocTypeFields = action.payload;
    },
    [postDLMDLMDocTypeFields.rejected]: (state) => {
      state.isLoadingPostDLMDocTypeFields = 'failed';
    },
    [getDLMDocTypeFields.pending]: (state) => {
      state.isLoadingListDLMDocTypeFields = 'loading';
    },
    [getDLMDocTypeFields.fulfilled]: (state, action) => {
      state.isLoadingListDLMDocTypeFields = 'success';
      state.listDLMDocTypeFields = action.payload;
    },
    [getDLMDocTypeFields.rejected]: (state) => {
      state.isLoadingListDLMDocTypeFields = 'failed';
    },
    [putDLMDocTypeFields.pending]: (state) => {
      state.isLoadingPutDLMDocTypeFields = 'loading';
    },
    [putDLMDocTypeFields.fulfilled]: (state, action) => {
      state.isLoadingPutDLMDocTypeFields = 'success';
      state.putDLMDocTypeFields = action.payload;
    },
    [putDLMDocTypeFields.rejected]: (state) => {
      state.isLoadingPutDLMDocTypeFields = 'failed';
    },
    [deleteDLMDocTypeFields.pending]: (state) => {
      state.isDeletingDLMDocTypeFields = 'loading';
    },
    [deleteDLMDocTypeFields.fulfilled]: (state) => {
      state.isDeletingDLMDocTypeFields = 'success';
    },
    [deleteDLMDocTypeFields.rejected]: (state) => {
      state.isDeletingDLMDocTypeFields = 'failed';
    },
    [postDLMDocTypeValidValues.pending]: (state) => {
      state.isLoadingPostDLMDocTypeValidValues = 'loading';
    },
    [postDLMDocTypeValidValues.fulfilled]: (state, action) => {
      state.isLoadingPostDLMDocTypeValidValues = 'success';
      state.postedDLMDocTypeValidValues = action.payload;
    },
    [postDLMDocTypeValidValues.rejected]: (state) => {
      state.isLoadingPostDLMDocTypeValidValues = 'failed';
    },
    [getDLMDocTypeValidValues.pending]: (state) => {
      state.isLoadingListDLMDocTypeValidValues = 'loading';
    },
    [getDLMDocTypeValidValues.fulfilled]: (state, action) => {
      state.isLoadingListDLMDocTypeValidValues = 'success';
      state.listDLMDocTypeFieldsValidValues = action.payload;
    },
    [getDLMDocTypeValidValues.rejected]: (state) => {
      state.isLoadingListDLMDocTypeValidValues = 'failed';
    },
    [putDLMDocTypeValidValues.pending]: (state) => {
      state.isLoadingPutDLMDocTypeValidValues = 'loading';
    },
    [putDLMDocTypeValidValues.fulfilled]: (state, action) => {
      state.isLoadingPutDLMDocTypeValidValues = 'success';
      state.putDLMDocTypeValidValues = action.payload;
    },
    [putDLMDocTypeValidValues.rejected]: (state) => {
      state.isLoadingPutDLMDocTypeValidValues = 'failed';
    },
    [deleteDLMDocTypeValidValues.pending]: (state) => {
      state.isDeletingDLMDocTypeValidValues = 'loading';
    },
    [deleteDLMDocTypeValidValues.fulfilled]: (state) => {
      state.isDeletingDLMDocTypeValidValues = 'success';
    },
    [deleteDLMDocTypeValidValues.rejected]: (state) => {
      state.isDeletingDLMDocTypeValidValues = 'failed';
    },
    [postDLMConfidentiality.pending]: (state) => {
      state.isLoadingPostDLMConfidentiality = 'loading';
    },
    [postDLMConfidentiality.fulfilled]: (state, action) => {
      state.isLoadingPostDLMConfidentiality = 'success';
      state.postedDLMConfidentiality = action.payload;
    },
    [postDLMConfidentiality.rejected]: (state) => {
      state.isLoadingPostDLMConfidentiality = 'failed';
    },
    [getDLMConfidentiality.pending]: (state) => {
      state.isLoadingListDLMConfidentiality = 'loading';
    },
    [getDLMConfidentiality.fulfilled]: (state, action) => {
      state.isLoadingListDLMConfidentiality = 'success';
      state.listDLMConfidentiality = action.payload;
    },
    [getDLMConfidentiality.rejected]: (state) => {
      state.isLoadingListDLMConfidentiality = 'failed';
    },
    [deleteDLMConfidentiality.pending]: (state) => {
      state.isDeletingDLMConfidentiality = 'loading';
    },
    [deleteDLMConfidentiality.fulfilled]: (state) => {
      state.isDeletingDLMConfidentiality = 'success';
    },
    [deleteDLMConfidentiality.rejected]: (state) => {
      state.isDeletingDLMConfidentiality = 'failed';
    },
    [postDLMUsersAccesses.pending]: (state) => {
      state.isLoadingPostDLMUsersAccesses = 'loading';
    },
    [postDLMUsersAccesses.fulfilled]: (state, action) => {
      state.isLoadingPostDLMUsersAccesses = 'success';
      state.postedDLMUsersAccesses = action.payload;
    },
    [postDLMUsersAccesses.rejected]: (state) => {
      state.isLoadingPostDLMUsersAccesses = 'failed';
    },
    [getDLMUsersAccesses.pending]: (state) => {
      state.isLoadingListDLMUsersAccesses = 'loading';
    },
    [getDLMUsersAccesses.fulfilled]: (state, action) => {
      state.isLoadingListDLMUsersAccesses = 'success';
      state.listDLMUsersAccesses = action.payload;
    },
    [getDLMUsersAccesses.rejected]: (state) => {
      state.isLoadingListDLMUsersAccesses = 'failed';
    },
    [deleteDLMUsersAccesses.pending]: (state) => {
      state.isDeletingDLMUsersAccesses = 'loading';
    },
    [deleteDLMUsersAccesses.fulfilled]: (state) => {
      state.isDeletingDLMUsersAccesses = 'success';
    },
    [deleteDLMUsersAccesses.rejected]: (state) => {
      state.isDeletingDLMUsersAccesses = 'failed';
    },
    [putDLMUsersAccesses.pending]: (state) => {
      state.isLoadingPutDLMUsersAccesses = 'loading';
    },
    [putDLMUsersAccesses.fulfilled]: (state, action) => {
      state.isLoadingPutDLMUsersAccesses = 'success';
      state.putDLMUsersAccesses = action.payload;
    },
    [putDLMUsersAccesses.rejected]: (state) => {
      state.isLoadingPutDLMUsersAccesses = 'failed';
    },
    [postCreateAccount.pending]: (state) => {
      state.isLoadingPostCreateAccount = 'loading';
    },
    [postCreateAccount.fulfilled]: (state, action) => {
      state.isLoadingPostCreateAccount = 'success';
      state.postedCreateAccount = action.payload;
    },
    [postCreateAccount.rejected]: (state) => {
      state.isLoadingPostCreateAccount = 'failed';
    },
    [getListAccount.pending]: (state) => {
      state.isLoadingListAccount = 'loading';
    },
    [getListAccount.fulfilled]: (state, action) => {
      state.isLoadingListAccount = 'success';
      state.listAccount = action.payload;
    },
    [getListAccount.rejected]: (state) => {
      state.isLoadingListAccount = 'failed';
    },
    [putUpdateAccount.pending]: (state) => {
      state.isLoadingPutUpdateAccount = 'loading';
    },
    [putUpdateAccount.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateAccount = 'success';
      state.putUpdateAccount = action.payload;
    },
    [putUpdateAccount.rejected]: (state) => {
      state.isLoadingPutUpdateAccount = 'failed';
    },
    [deleteAccount.pending]: (state) => {
      state.isDeletingAccount = 'loading';
    },
    [deleteAccount.fulfilled]: (state) => {
      state.isDeletingAccount = 'success';
    },
    [deleteAccount.rejected]: (state) => {
      state.isDeletingAccount = 'failed';
    },
    [postCreateBank.pending]: (state) => {
      state.isLoadingPostCreateBank = 'loading';
    },
    [postCreateBank.fulfilled]: (state, action) => {
      state.isLoadingPostCreateBank = 'success';
      state.postedCreateBank = action.payload;
    },
    [postCreateBank.rejected]: (state) => {
      state.isLoadingPostCreateBank = 'failed';
    },
    [getListBank.pending]: (state) => {
      state.isLoadingListBank = 'loading';
    },
    [getListBank.fulfilled]: (state, action) => {
      state.isLoadingListBank = 'success';
      state.listBank = action.payload;
    },
    [getListBank.rejected]: (state) => {
      state.isLoadingListBank = 'failed';
    },
    [putUpdateBank.pending]: (state) => {
      state.isLoadingPutUpdateBank = 'loading';
    },
    [putUpdateBank.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateBank = 'success';
      state.putUpdateBank = action.payload;
    },
    [putUpdateBank.rejected]: (state) => {
      state.isLoadingPutUpdateBank = 'failed';
    },
    [deleteBank.pending]: (state) => {
      state.isDeletingBank = 'loading';
    },
    [deleteBank.fulfilled]: (state) => {
      state.isDeletingBank = 'success';
    },
    [deleteBank.rejected]: (state) => {
      state.isDeletingBank = 'failed';
    },
    [getListExtract.pending]: (state) => {
      state.isLoadingListExtract = 'loading';
    },
    [getListExtract.fulfilled]: (state, action) => {
      state.isLoadingListExtract = 'success';
      state.listExtract = action.payload;
    },
    [getListExtract.rejected]: (state) => {
      state.isLoadingListExtract = 'failed';
    },
    [deleteExtract.pending]: (state) => {
      state.isDeletingExtract = 'loading';
    },
    [deleteExtract.fulfilled]: (state) => {
      state.isDeletingExtract = 'success';
    },
    [deleteExtract.rejected]: (state) => {
      state.isDeletingExtract = 'failed';
    },
    [getListCategory.pending]: (state) => {
      state.isLoadingListCategory = 'loading';
    },
    [getListCategory.fulfilled]: (state, action) => {
      state.isLoadingListCategory = 'success';
      state.listCategory = action.payload;
    },
    [getListCategory.rejected]: (state) => {
      state.isLoadingListCategory = 'failed';
    },
    [postCreateCategory.pending]: (state) => {
      state.isLoadingPostCreateCategory = 'loading';
    },
    [postCreateCategory.fulfilled]: (state, action) => {
      state.isLoadingPostCreateCategory = 'success';
      state.postedCreateCategory = action.payload;
    },
    [postCreateCategory.rejected]: (state) => {
      state.isLoadingPostCreateCategory = 'failed';
    },
    [putUpdateCategory.pending]: (state) => {
      state.isLoadingPutUpdateCategory = 'loading';
    },
    [putUpdateCategory.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateCategory = 'success';
      state.putUpdateCategory = action.payload;
    },
    [putUpdateCategory.rejected]: (state) => {
      state.isLoadingPutUpdateCategory = 'failed';
    },
    [deleteCategory.pending]: (state) => {
      state.isDeletingCategory = 'loading';
    },
    [deleteCategory.fulfilled]: (state) => {
      state.isDeletingCategory = 'success';
    },
    [deleteCategory.rejected]: (state) => {
      state.isDeletingCategory = 'failed';
    },
    [getListLancamento.pending]: (state) => {
      state.isLoadingListLancamento = 'loading';
    },
    [getListLancamento.fulfilled]: (state, action) => {
      state.isLoadingListLancamento = 'success';
      state.listLancamento = action.payload;
    },
    [getListLancamento.rejected]: (state) => {
      state.isLoadingListLancamento = 'failed';
    },
    [postCreateLancamento.pending]: (state) => {
      state.isLoadingPostCreateLancamento = 'loading';
    },
    [postCreateLancamento.fulfilled]: (state, action) => {
      state.isLoadingPostCreateLancamento = 'success';
      state.postedCreateLancamento = action.payload;
    },
    [postCreateLancamento.rejected]: (state) => {
      state.isLoadingPostCreateLancamento = 'failed';
    },
    [putUpdatelancamento.pending]: (state) => {
      state.isLoadingPutUpdateLancamento = 'loading';
    },
    [putUpdatelancamento.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateLancamento = 'success';
      state.putUpdateLancamento = action.payload;
    },
    [putUpdatelancamento.rejected]: (state) => {
      state.isLoadingPutUpdateLancamento = 'failed';
    },
    [deleteLancamento.pending]: (state) => {
      state.isDeletingLancamento = 'loading';
    },
    [deleteLancamento.fulfilled]: (state) => {
      state.isDeletingLancamento = 'success';
    },
    [deleteLancamento.rejected]: (state) => {
      state.isDeletingLancamento = 'failed';
    },
    [getListConciliacao.pending]: (state) => {
      state.isLoadingListConciliacao = 'loading';
    },
    [getListConciliacao.fulfilled]: (state, action) => {
      state.isLoadingListConciliacao = 'success';
      state.listConciliacao = action.payload;
    },
    [getListConciliacao.rejected]: (state) => {
      state.isLoadingListConciliacao = 'failed';
    },
    [getListSimulacao.pending]: (state) => {
      state.isLoadingListSimulacao = 'loading';
    },
    [getListSimulacao.fulfilled]: (state, action) => {
      state.isLoadingListSimulacao = 'success';
      state.listSimulacao = action.payload;
    },
    [getListSimulacao.rejected]: (state) => {
      state.isLoadingListSimulacao = 'failed';
    },
    [putUpdateVincMovimentacao.pending]: (state) => {
      state.isLoadingPutUpdateVincMovimentacao = 'loading';
    },
    [putUpdateVincMovimentacao.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateVincMovimentacao = 'success';
      state.putUpdateVincMovimentacao = action.payload;
    },
    [putUpdateVincMovimentacao.rejected]: (state) => {
      state.isLoadingPutUpdateVincMovimentacao = 'failed';
    },
    [putUpdateDesvincMovimentacao.pending]: (state) => {
      state.isLoadingPutUpdateDesvincMovimentacao = 'loading';
    },
    [putUpdateDesvincMovimentacao.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateDesvincMovimentacao = 'success';
      state.putUpdateDesvincMovimentacao = action.payload;
    },
    [putUpdateDesvincMovimentacao.rejected]: (state) => {
      state.isLoadingPutUpdateDesvincMovimentacao = 'failed';
    },
    [getListSimulacaoConta.pending]: (state) => {
      state.isLoadingListSimulacaoConta = 'loading';
      state.listSimulacaoConta = {};
    },
    [getListSimulacaoConta.fulfilled]: (state, action) => {
      state.isLoadingListSimulacaoConta = 'success';
      state.listSimulacaoConta = action.payload;
    },
    [getListSimulacaoConta.rejected]: (state) => {
      state.isLoadingListSimulacaoConta = 'failed';
      state.listSimulacaoConta = {};
    },
    [postCreateLancamentoConciliacao.pending]: (state) => {
      state.isLoadingPostCreateLancamentoConciliacao = 'loading';
    },
    [postCreateLancamentoConciliacao.fulfilled]: (state, action) => {
      state.isLoadingPostCreateLancamentoConciliacao = 'success';
      state.postedCreateLancamentoConciliacao = action.payload;
    },
    [postCreateLancamentoConciliacao.rejected]: (state) => {
      state.isLoadingPostCreateLancamentoConciliacao = 'failed';
    },
    [getExecuteConciliacao.pending]: (state) => {
      state.isLoadingExecuteConciliacao = 'loading';
    },
    [getExecuteConciliacao.fulfilled]: (state, action) => {
      state.isLoadingExecuteConciliacao = 'success';
      state.listExecuteConciliacao = action.payload;
    },
    [getExecuteConciliacao.rejected]: (state) => {
      state.isLoadingExecuteConciliacao = 'failed';
    },
    [getGestaoFinanceiraContato.pending]: (state) => {
      state.isLoadingGestaoFinanceiraContato = 'loading';
    },
    [getGestaoFinanceiraContato.fulfilled]: (state, action) => {
      state.isLoadingGestaoFinanceiraContato = 'success';
      state.listGestaoFinanceiraContato = action.payload;
    },
    [getGestaoFinanceiraContato.rejected]: (state) => {
      state.isLoadingGestaoFinanceiraContato = 'failed';
    },
    [getExtractMovements.pending]: (state) => {
      state.isLoadingExtractMovements = 'loading';
    },
    [getExtractMovements.fulfilled]: (state, action) => {
      state.isLoadingExtractMovements = 'success';
      state.listExtractMovements = action.payload;
    },
    [getExtractMovements.rejected]: (state) => {
      state.isLoadingExtractMovements = 'failed';
    },
    [getValidateExtract.pending]: (state) => {
      state.isLoadingValidateExtract = 'loading';
    },
    [getValidateExtract.fulfilled]: (state, action) => {
      state.isLoadingValidateExtract = 'success';
      state.listValidateExtract = action.payload;
    },
    [getValidateExtract.rejected]: (state) => {
      state.isLoadingValidateExtract = 'failed';
    },
    [getTransferenciaConta.pending]: (state) => {
      state.isLoadingTransferenciaConta = 'loading';
    },
    [getTransferenciaConta.fulfilled]: (state, action) => {
      state.isLoadingTransferenciaConta = 'success';
      state.listTransferenciaConta = action.payload;
    },
    [getTransferenciaConta.rejected]: (state) => {
      state.isLoadingTransferenciaConta = 'failed';
    },
    [postTransferenciaConta.pending]: (state) => {
      state.isLoadingPostTransferenciaConta = 'loading';
    },
    [postTransferenciaConta.fulfilled]: (state, action) => {
      state.isLoadingPostTransferenciaConta = 'success';
      state.postedTransferenciaConta = action.payload;
    },
    [postTransferenciaConta.rejected]: (state) => {
      state.isLoadingPostTransferenciaConta = 'failed';
    },
    [getLevdataEmpresaInfo.pending]: (state) => {
      state.isLoadingLevidataEmpresaInfo = 'loading';
    },
    [getLevdataEmpresaInfo.fulfilled]: (state, action) => {
      state.isLoadingLevidataEmpresaInfo = 'success';
      state.listLevdataEmpresaInfo = action.payload;
    },
    [getLevdataEmpresaInfo.rejected]: (state) => {
      state.isLoadingLevidataEmpresaInfo = 'failed';
    },
    [getLevdataImpostos.pending]: (state) => {
      state.isLoadingLevidataImpostos = 'loading';
    },
    [getLevdataImpostos.fulfilled]: (state, action) => {
      state.isLoadingLevidataImpostos = 'success';
      state.listLevdataImpostos = action.payload;
    },
    [getLevdataImpostos.rejected]: (state) => {
      state.isLoadingLevidataImpostos = 'failed';
    },
    [getLevdataMargem.pending]: (state) => {
      state.isLoadingLevidataMargem = 'loading';
    },
    [getLevdataMargem.fulfilled]: (state, action) => {
      state.isLoadingLevidataMargem = 'success';
      state.listLevdataMargem = action.payload;
    },
    [getLevdataMargem.rejected]: (state) => {
      state.isLoadingLevidataMargem = 'failed';
    },
    [getLevdataSituacaoTributaria.pending]: (state) => {
      state.isLoadingLevidataSituacaoTributaria = 'loading';
    },
    [getLevdataSituacaoTributaria.fulfilled]: (state, action) => {
      state.isLoadingLevidataSituacaoTributaria = 'success';
      state.listLevdataSituacaoTributaria = action.payload;
    },
    [getLevdataSituacaoTributaria.rejected]: (state) => {
      state.isLoadingLevidataSituacaoTributaria = 'failed';
    },
    [getLevdataLevNotas.pending]: (state) => {
      state.isLoadingLevidataLevNotas = 'loading';
    },
    [getLevdataLevNotas.fulfilled]: (state, action) => {
      state.isLoadingLevidataLevNotas = 'success';
      state.listLevdataLevNotas = action.payload;
    },
    [getLevdataLevNotas.rejected]: (state) => {
      state.isLoadingLevidataLevNotas = 'failed';
    },
    [getLevdataReceita.pending]: (state) => {
      state.isLoadingLevidataReceita = 'loading';
    },
    [getLevdataReceita.fulfilled]: (state, action) => {
      state.isLoadingLevidataReceita = 'success';
      state.listLevdataReceita = action.payload;
    },
    [getLevdataReceita.rejected]: (state) => {
      state.isLoadingLevidataReceita = 'failed';
    },
    [getLevdataHistoricoDashboard.pending]: (state) => {
      state.isLoadingLevidataHistoricoDashboard = 'loading';
    },
    [getLevdataHistoricoDashboard.fulfilled]: (state, action) => {
      state.isLoadingLevidataHistoricoDashboard = 'success';
      state.listLevdataHistoricoDashboard = action.payload;
    },
    [getLevdataHistoricoDashboard.rejected]: (state) => {
      state.isLoadingLevidataHistoricoDashboard = 'failed';
    },
    [getLevdataComprasEntrada.pending]: (state) => {
      state.isLoadingLevidataComprasEntrada = 'loading';
    },
    [getLevdataComprasEntrada.fulfilled]: (state, action) => {
      state.isLoadingLevidataComprasEntrada = 'success';
      state.listLevdataComprasEntrada = action.payload;
    },
    [getLevdataComprasEntrada.rejected]: (state) => {
      state.isLoadingLevidataComprasEntrada = 'failed';
    },
    [getLevdataLimiteUtilizado.pending]: (state) => {
      state.isLoadingLevidataLimiteUtilizado = 'loading';
    },
    [getLevdataLimiteUtilizado.fulfilled]: (state, action) => {
      state.isLoadingLevidataLimiteUtilizado = 'success';
      state.listLevdataLimiteUtilizado = action.payload;
    },
    [getLevdataLimiteUtilizado.rejected]: (state) => {
      state.isLoadingLevidataLimiteUtilizado = 'failed';
    },
    [getLevdataRegimeAtual.pending]: (state) => {
      state.isLoadingLevidataRegimeAtual = 'loading';
    },
    [getLevdataRegimeAtual.fulfilled]: (state, action) => {
      state.isLoadingLevidataRegimeAtual = 'success';
      state.listLevdataRegimeAtual = action.payload;
    },
    [getLevdataRegimeAtual.rejected]: (state) => {
      state.isLoadingLevidataRegimeAtual = 'failed';
    },
    [getLevdataAliquotaAtual.pending]: (state) => {
      state.isLoadingLevidataAliquotaAtual = 'loading';
    },
    [getLevdataAliquotaAtual.fulfilled]: (state, action) => {
      state.isLoadingLevidataAliquotaAtual = 'success';
      state.listLevdataAliquotaAtual = action.payload;
    },
    [getLevdataAliquotaAtual.rejected]: (state) => {
      state.isLoadingLevidataAliquotaAtual = 'failed';
    },
    [getLevdataDespesas.pending]: (state) => {
      state.isLoadingLevidataDespesas = 'loading';
    },
    [getLevdataDespesas.fulfilled]: (state, action) => {
      state.isLoadingLevidataDespesas = 'success';
      state.listLevdataDespesas = action.payload;
    },
    [getLevdataDespesas.rejected]: (state) => {
      state.isLoadingLevidataDespesas = 'failed';
    },
    [getLevdataReceitaDiagnostico.pending]: (state) => {
      state.isLoadingLevidataReceitaDiagnostico = 'loading';
    },
    [getLevdataReceitaDiagnostico.fulfilled]: (state, action) => {
      state.isLoadingLevidataReceitaDiagnostico = 'success';
      state.listLevdataReceitaDiagnostico = action.payload;
    },
    [getLevdataReceitaDiagnostico.rejected]: (state) => {
      state.isLoadingLevidataReceitaDiagnostico = 'failed';
    },
    [getLevdataDespesasDiagnostico.pending]: (state) => {
      state.isLoadingLevidataDespesasDiagnostico = 'loading';
    },
    [getLevdataDespesasDiagnostico.fulfilled]: (state, action) => {
      state.isLoadingLevidataDespesasDiagnostico = 'success';
      state.listLevdataDespesasDiagnostico = action.payload;
    },
    [getLevdataDespesasDiagnostico.rejected]: (state) => {
      state.isLoadingLevidataDespesasDiagnostico = 'failed';
    },
    [getLevdataCreditoPotencialDiagnostico.pending]: (state) => {
      state.isLoadingLevidataCreditoPotencialDiagnostico = 'loading';
    },
    [getLevdataCreditoPotencialDiagnostico.fulfilled]: (state, action) => {
      state.isLoadingLevidataCreditoPotencialDiagnostico = 'success';
      state.listLevdataCreditoPotencialDiagnostico = action.payload;
    },
    [getLevdataCreditoPotencialDiagnostico.rejected]: (state) => {
      state.isLoadingLevidataCreditoPotencialDiagnostico = 'failed';
    },
    [getLevdataCreditoPotencial.pending]: (state) => {
      state.isLoadingLevidataCreditoPotencial = 'loading';
    },
    [getLevdataCreditoPotencial.fulfilled]: (state, action) => {
      state.isLoadingLevidataCreditoPotencial = 'success';
      state.listLevdataCreditoPotencial = action.payload;
    },
    [getLevdataCreditoPotencial.rejected]: (state) => {
      state.isLoadingLevidataCreditoPotencial = 'failed';
    },
    [getLevdataComprasSemCredito.pending]: (state) => {
      state.isLoadingLevidataComprasSemCredito = 'loading';
    },
    [getLevdataComprasSemCredito.fulfilled]: (state, action) => {
      state.isLoadingLevidataComprasSemCredito = 'success';
      state.listLevdataComprasSemCredito = action.payload;
    },
    [getLevdataComprasSemCredito.rejected]: (state) => {
      state.isLoadingLevidataComprasSemCredito = 'failed';
    },
    [getLevdataDetalhamentoLucro.pending]: (state) => {
      state.isLoadingLevidataDetalhamentoLucro = 'loading';
    },
    [getLevdataDetalhamentoLucro.fulfilled]: (state, action) => {
      state.isLoadingLevidataDetalhamentoLucro = 'success';
      state.listLevdataDetalhamentoLucro = action.payload;
    },
    [getLevdataDetalhamentoLucro.rejected]: (state) => {
      state.isLoadingLevidataDetalhamentoLucro = 'failed';
    },
    [getLevdataCreditosFiscais.pending]: (state) => {
      state.isLoadingLevidataCreditosFiscais = 'loading';
    },
    [getLevdataCreditosFiscais.fulfilled]: (state, action) => {
      state.isLoadingLevidataCreditosFiscais = 'success';
      state.listLevdataCreditosFiscais = action.payload;
    },
    [getLevdataCreditosFiscais.rejected]: (state) => {
      state.isLoadingLevidataCreditosFiscais = 'failed';
    },
    [getLevdataFornecedorPorCredito.pending]: (state) => {
      state.isLoadingLevidataFornecedorPorCredito = 'loading';
    },
    [getLevdataFornecedorPorCredito.fulfilled]: (state, action) => {
      state.isLoadingLevidataFornecedorPorCredito = 'success';
      state.listLevdataFornecedorPorCredito = action.payload;
    },
    [getLevdataFornecedorPorCredito.rejected]: (state) => {
      state.isLoadingLevidataFornecedorPorCredito = 'failed';
    },
    [getLevdataSemCreditoPotencial.pending]: (state) => {
      state.isLoadingLevidataSemCreditoPotencial = 'loading';
    },
    [getLevdataSemCreditoPotencial.fulfilled]: (state, action) => {
      state.isLoadingLevidataSemCreditoPotencial = 'success';
      state.listLevdataSemCreditoPotencial = action.payload;
    },
    [getLevdataSemCreditoPotencial.rejected]: (state) => {
      state.isLoadingLevidataSemCreditoPotencial = 'failed';
    },
    [getLevdataCreditoPisCofins.pending]: (state) => {
      state.isLoadingLevidataCreditoPisCofins = 'loading';
    },
    [getLevdataCreditoPisCofins.fulfilled]: (state, action) => {
      state.isLoadingLevidataCreditoPisCofins = 'success';
      state.listLevdataCreditoPisCofins = action.payload;
    },
    [getLevdataCreditoPisCofins.rejected]: (state) => {
      state.isLoadingLevidataCreditoPisCofins = 'failed';
    },
    [getLevdataHistoricoCreditos.pending]: (state) => {
      state.isLoadingLevidataHistoricoCreditos = 'loading';
    },
    [getLevdataHistoricoCreditos.fulfilled]: (state, action) => {
      state.isLoadingLevidataHistoricoCreditos = 'success';
      state.listLevdataHistoricoCreditos = action.payload;
    },
    [getLevdataHistoricoCreditos.rejected]: (state) => {
      state.isLoadingLevidataHistoricoCreditos = 'failed';
    },
    [getLevdataDashboardInsights.pending]: (state) => {
      state.isLoadingLevidataDashboardInsights = 'loading';
    },
    [getLevdataDashboardInsights.fulfilled]: (state, action) => {
      state.isLoadingLevidataDashboardInsights = 'success';
      state.listLevdataDashboardInsights = action.payload;
    },
    [getLevdataDashboardInsights.rejected]: (state) => {
      state.isLoadingLevidataDashboardInsights = 'failed';
    },
    [getFinanceiroDashboardProdutos.pending]: (state) => {
      state.isLoadingFinanceiroDashboardProdutos = 'loading';
    },
    [getFinanceiroDashboardProdutos.fulfilled]: (state, action) => {
      state.isLoadingFinanceiroDashboardProdutos = 'success';
      state.listFinanceiroDashboardProdutos = action.payload;
    },
    [getFinanceiroDashboardProdutos.rejected]: (state) => {
      state.isLoadingFinanceiroDashboardProdutos = 'failed';
    },
    [getFinanceiroDashboardClientes.pending]: (state) => {
      state.isLoadingFinanceiroDashboardClientes = 'loading';
    },
    [getFinanceiroDashboardClientes.fulfilled]: (state, action) => {
      state.isLoadingFinanceiroDashboardClientes = 'success';
      state.listFinanceiroDashboardClientes = action.payload;
    },
    [getFinanceiroDashboardClientes.rejected]: (state) => {
      state.isLoadingFinanceiroDashboardClientes = 'failed';
    },
    [getFinanceiroDashboardMotorInsights.pending]: (state) => {
      state.isLoadingFinanceiroDashboardMotorInsights = 'loading';
    },
    [getFinanceiroDashboardMotorInsights.fulfilled]: (state, action) => {
      state.isLoadingFinanceiroDashboardMotorInsights = 'success';
      state.listFinanceiroDashboardMotorInsights = action.payload;
    },
    [getFinanceiroDashboardMotorInsights.rejected]: (state) => {
      state.isLoadingFinanceiroDashboardMotorInsights = 'failed';
    },
    [getFinanceiroDashboardProdutoOpcoes.pending]: (state) => {
      state.isLoadingFinanceiroDashboardProdutoOpcoes = 'loading';
    },
    [getFinanceiroDashboardProdutoOpcoes.fulfilled]: (state, action) => {
      state.isLoadingFinanceiroDashboardProdutoOpcoes = 'success';
      state.listFinanceiroDashboardProdutoOpcoes = action.payload;
    },
    [getFinanceiroDashboardProdutoOpcoes.rejected]: (state) => {
      state.isLoadingFinanceiroDashboardProdutoOpcoes = 'failed';
    },
    [getFinanceiroDashboardClienteOpcoes.pending]: (state) => {
      state.isLoadingFinanceiroDashboardClienteOpcoes = 'loading';
    },
    [getFinanceiroDashboardClienteOpcoes.fulfilled]: (state, action) => {
      state.isLoadingFinanceiroDashboardClienteOpcoes = 'success';
      state.listFinanceiroDashboardClienteOpcoes = action.payload;
    },
    [getFinanceiroDashboardClienteOpcoes.rejected]: (state) => {
      state.isLoadingFinanceiroDashboardClienteOpcoes = 'failed';
    },
    [getLevdataCenarioVendas.pending]: (state) => {
      state.isLoadingLevidataCenarioVendas = 'loading';
    },
    [getLevdataCenarioVendas.fulfilled]: (state, action) => {
      state.isLoadingLevidataCenarioVendas = 'success';
      state.listLevdataCenarioVendas = action.payload;
    },
    [getLevdataCenarioVendas.rejected]: (state) => {
      state.isLoadingLevidataCenarioVendas = 'failed';
    },
    [getLevdataCreditosPotenciaisInsights.pending]: (state) => {
      state.isLoadingLevidataCreditosPotenciaisInsights = 'loading';
    },
    [getLevdataCreditosPotenciaisInsights.fulfilled]: (state, action) => {
      state.isLoadingLevidataCreditosPotenciaisInsights = 'success';
      state.listLevdataCreditosPotenciaisInsights = action.payload;
    },
    [getLevdataCreditosPotenciaisInsights.rejected]: (state) => {
      state.isLoadingLevidataCreditosPotenciaisInsights = 'failed';
    },
    [getLevdataRegimeTributarioSimulacao.pending]: (state) => {
      state.isLoadingLevidataRegimeTributarioSimulacao = 'loading';
    },
    [getLevdataRegimeTributarioSimulacao.fulfilled]: (state, action) => {
      state.isLoadingLevidataRegimeTributarioSimulacao = 'success';
      state.listLevdataRegimeTributarioSimulacao = action.payload;
    },
    [getLevdataRegimeTributarioSimulacao.rejected]: (state) => {
      state.isLoadingLevidataRegimeTributarioSimulacao = 'failed';
    },
    [getLevdataRegimeTributarioComparativo.pending]: (state) => {
      state.isLoadingLevidataRegimeTributarioComparativo = 'loading';
    },
    [getLevdataRegimeTributarioComparativo.fulfilled]: (state, action) => {
      state.isLoadingLevidataRegimeTributarioComparativo = 'success';
      state.listLevdataRegimeTributarioComparativo = action.payload;
    },
    [getLevdataRegimeTributarioComparativo.rejected]: (state) => {
      state.isLoadingLevidataRegimeTributarioComparativo = 'failed';
    },
    [getLevdataRegimeTributarioMotorExecutivo.pending]: (state) => {
      state.isLoadingLevidataRegimeTributarioMotorExecutivo = 'loading';
    },
    [getLevdataRegimeTributarioMotorExecutivo.fulfilled]: (state, action) => {
      state.isLoadingLevidataRegimeTributarioMotorExecutivo = 'success';
      state.listLevdataRegimeTributarioMotorExecutivo = action.payload;
    },
    [getLevdataRegimeTributarioMotorExecutivo.rejected]: (state) => {
      state.isLoadingLevidataRegimeTributarioMotorExecutivo = 'failed';
    },
    [postLevdataPrecificacaoNotaValor.pending]: (state) => {
      state.isLoadingPostLevidataPrecificacaoNotaValor = 'loading';
    },
    [postLevdataPrecificacaoNotaValor.fulfilled]: (state, action) => {
      state.isLoadingPostLevidataPrecificacaoNotaValor = 'success';
      state.postedLevdataPrecificacaoNotaValor = action.payload;
    },
    [postLevdataPrecificacaoNotaValor.rejected]: (state) => {
      state.isLoadingPostLevidataPrecificacaoNotaValor = 'failed';
    },
    [getLevdataPrecificacaoProdutoNfe.pending]: (state) => {
      state.isLoadingLevidataPrecificacaoProdutoNfe = 'loading';
    },
    [getLevdataPrecificacaoProdutoNfe.fulfilled]: (state, action) => {
      state.isLoadingLevidataPrecificacaoProdutoNfe = 'success';
      state.listLevdataPrecificacaoProdutoNfe = action.payload;
    },
    [getLevdataPrecificacaoProdutoNfe.rejected]: (state) => {
      state.isLoadingLevidataPrecificacaoProdutoNfe = 'failed';
    },
    [getLevdataPrecificacaoProdutoNfse.pending]: (state) => {
      state.isLoadingLevidataPrecificacaoProdutoNfse = 'loading';
    },
    [getLevdataPrecificacaoProdutoNfse.fulfilled]: (state, action) => {
      state.isLoadingLevidataPrecificacaoProdutoNfse = 'success';
      state.listLevdataPrecificacaoProdutoNfse = action.payload;
    },
    [getLevdataPrecificacaoProdutoNfse.rejected]: (state) => {
      state.isLoadingLevidataPrecificacaoProdutoNfse = 'failed';
    },
    [postLevdataPrecificacaoCombinarProduto.pending]: (state) => {
      state.isLoadingPostLevidataPrecificacaoCombinarProduto = 'loading';
    },
    [postLevdataPrecificacaoCombinarProduto.fulfilled]: (state, action) => {
      state.isLoadingPostLevidataPrecificacaoCombinarProduto = 'success';
      state.listPostLevidataPrecificacaoCombinarProduto = action.payload;
    },
    [postLevdataPrecificacaoCombinarProduto.rejected]: (state) => {
      state.isLoadingPostLevidataPrecificacaoCombinarProduto = 'failed';
    },
    [postLevdataPrecificacaoCombinarServico.pending]: (state) => {
      state.isLoadingPostLevidataPrecificacaoCombinarServico = 'loading';
    },
    [postLevdataPrecificacaoCombinarServico.fulfilled]: (state, action) => {
      state.isLoadingPostLevidataPrecificacaoCombinarServico = 'success';
      state.listPostLevidataPrecificacaoCombinarServico = action.payload;
    },
    [postLevdataPrecificacaoCombinarServico.rejected]: (state) => {
      state.isLoadingPostLevidataPrecificacaoCombinarServico = 'failed';
    },
    [getLevdataPrecificacaoFavoritos.pending]: (state) => {
      state.isLoadingLevidataPrecificacaoFavoritos = 'loading';
    },
    [getLevdataPrecificacaoFavoritos.fulfilled]: (state, action) => {
      state.isLoadingLevidataPrecificacaoFavoritos = 'success';
      state.listLevdataPrecificacaoFavoritos = action.payload;
    },
    [getLevdataPrecificacaoFavoritos.rejected]: (state) => {
      state.isLoadingLevidataPrecificacaoFavoritos = 'failed';
    },
    [postLevdataPrecificacaoToggleFavorito.fulfilled]: (state) => {
      state.isLoadingPostLevidataPrecificacaoToggleFavorito = 'success';
    },
    [postLevdataPrecificacaoToggleFavorito.rejected]: (state) => {
      state.isLoadingPostLevidataPrecificacaoToggleFavorito = 'failed';
    },
    [getLevdataPrecificacaoSimulacaoProduto.pending]: (state) => {
      state.isLoadingLevidataPrecificacaoSimulacaoProduto = 'loading';
    },
    [getLevdataPrecificacaoSimulacaoProduto.fulfilled]: (state, action) => {
      state.isLoadingLevidataPrecificacaoSimulacaoProduto = 'success';
      state.listLevdataPrecificacaoSimulacaoProduto = action.payload;
    },
    [getLevdataPrecificacaoSimulacaoProduto.rejected]: (state) => {
      state.isLoadingLevidataPrecificacaoSimulacaoProduto = 'failed';
    },
    [getLevdataPrecificacaoCalculoCenario.pending]: (state) => {
      state.isLoadingLevidataPrecificacaoCalculoCenario = 'loading';
    },
    [getLevdataPrecificacaoCalculoCenario.fulfilled]: (state, action) => {
      state.isLoadingLevidataPrecificacaoCalculoCenario = 'success';
      state.listLevdataPrecificacaoCalculoCenario = action.payload;
    },
    [getLevdataPrecificacaoCalculoCenario.rejected]: (state) => {
      state.isLoadingLevidataPrecificacaoCalculoCenario = 'failed';
    },
    [getLevdataPrecificacaoCalculoTributario.pending]: (state) => {
      state.isLoadingLevidataPrecificacaoCalculoTributario = 'loading';
    },
    [getLevdataPrecificacaoCalculoTributario.fulfilled]: (state, action) => {
      state.isLoadingLevidataPrecificacaoCalculoTributario = 'success';
      state.listLevdataPrecificacaoCalculoTributario = action.payload;
    },
    [getLevdataPrecificacaoCalculoTributario.rejected]: (state) => {
      state.isLoadingLevidataPrecificacaoCalculoTributario = 'failed';
    },
    [getLevdataPrecificacaoHistorico.pending]: (state) => {
      state.isLoadingLevidataPrecificacaoHistorico = 'loading';
    },
    [getLevdataPrecificacaoHistorico.fulfilled]: (state, action) => {
      state.isLoadingLevidataPrecificacaoHistorico = 'success';
      state.listLevdataPrecificacaoHistorico = action.payload;
    },
    [getLevdataPrecificacaoHistorico.rejected]: (state) => {
      state.isLoadingLevidataPrecificacaoHistorico = 'failed';
    },
    [getTabelaBc.pending]: (state) => {
      state.isLoadingTabelaBc = 'loading';
    },
    [getTabelaBc.fulfilled]: (state, action) => {
      state.isLoadingTabelaBc = 'success';
      state.listTabelaBc = action.payload;
    },
    [getTabelaBc.rejected]: (state) => {
      state.isLoadingTabelaBc = 'failed';
    },
    [getListaCnae.pending]: (state) => {
      state.isLoadingListaCnae = 'loading';
    },
    [getListaCnae.fulfilled]: (state, action) => {
      state.isLoadingListaCnae = 'success';
      state.listListaCnae = action.payload;
    },
    [getListaCnae.rejected]: (state) => {
      state.isLoadingListaCnae = 'failed';
    },
    [putUpdateCnaeIdBc.pending]: (state) => {
      state.isLoadingUpdateCnaeIdBc = 'loading';
    },
    [putUpdateCnaeIdBc.fulfilled]: (state, action) => {
      state.isLoadingUpdateCnaeIdBc = 'success';
      state.updatedCnaeIdBc = action.payload;
    },
    [putUpdateCnaeIdBc.rejected]: (state) => {
      state.isLoadingUpdateCnaeIdBc = 'failed';
    },
    [postCreateTabelaBc.pending]: (state) => {
      state.isLoadingPostCreateTabelaBc = 'loading';
    },
    [postCreateTabelaBc.fulfilled]: (state, action) => {
      state.isLoadingPostCreateTabelaBc = 'success';
      state.postedCreateTabelaBc = action.payload;
    },
    [postCreateTabelaBc.rejected]: (state) => {
      state.isLoadingPostCreateTabelaBc = 'failed';
    },
    [putUpdateTabelaBc.pending]: (state) => {
      state.isLoadingPutUpdateTabelaBc = 'loading';
    },
    [putUpdateTabelaBc.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateTabelaBc = 'success';
      state.updatedTabelaBc = action.payload;
    },
    [putUpdateTabelaBc.rejected]: (state) => {
      state.isLoadingPutUpdateTabelaBc = 'failed';
    },
    [deleteTabelaBc.pending]: (state) => {
      state.isDeletingTabelaBc = 'loading';
    },
    [deleteTabelaBc.fulfilled]: (state, action) => {
      state.isDeletingTabelaBc = 'success';
      state.deletedTabelaBc = action.payload;
    },
    [deleteTabelaBc.rejected]: (state) => {
      state.isDeletingTabelaBc = 'failed';
    },
    [putUpdateCnae.pending]: (state) => {
      state.isLoadingPutUpdateCnae = 'loading';
    },
    [putUpdateCnae.fulfilled]: (state, action) => {
      state.isLoadingPutUpdateCnae = 'success';
      state.updatedCnae = action.payload;
    },
    [putUpdateCnae.rejected]: (state) => {
      state.isLoadingPutUpdateCnae = 'failed';
    },
    [deleteListaCnae.pending]: (state) => {
      state.isDeletingListaCnae = 'loading';
    },
    [deleteListaCnae.fulfilled]: (state, action) => {
      state.isDeletingListaCnae = 'success';
      state.deletedListaCnae = action.payload;
    },
    [deleteListaCnae.rejected]: (state) => {
      state.isDeletingListaCnae = 'failed';
    },
    [postCreateCnae.pending]: (state) => {
      state.isLoadingPostCreateCnae = 'loading';
    },
    [postCreateCnae.fulfilled]: (state, action) => {
      state.isLoadingPostCreateCnae = 'success';
      state.postedCreateCnae = action.payload;
    },
    [postCreateCnae.rejected]: (state) => {
      state.isLoadingPostCreateCnae = 'failed';
    }
  }
});

export const subidaDeDocumentosSelector = (state) =>
  state.subidaDeDocumentosData;

export default subidaDeDocumentosDataSlice.reducer;
